import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";

import providersService from "@services/providers";
import nifService from "@services/nif";
import productsService from "@services/products";
import postosService from "@services/postos";
import categoriesService from "@services/categories";
import customersService from "@services/customers";
import taxService from "@services/tax";
import ordersService from "@services/orders";

// Components
import Menu from "@components/Menu";

/* Import Components */
// Removed unused imports: Input, Button, AutoComplete, Checkbox, MdClear, MdOutlineWarning, MdAddCircleOutline, MdTurnLeft

import { currentDateTime, currentDate, dateToTimestamp } from "@utils/date";
import { threeDecimal, applyDiscount, revertDiscount } from "@utils/format";
import { getTaxSelectLabel } from "@utils/taxLabel";
import { totals } from "./utils/totals";

import UserContext from "@components/context/userContext";

// Import components
import HeaderForm from "./components/HeaderForm";
import ProductLines from "./components/ProductLines";
import TotalsSection from "./components/TotalsSection";
import ActionButtons, { AddItemButton } from "./components/ActionButtons";
import BarcodeProductModal from "@components/BarcodeProductModal";
import QRReaderModal from "./components/QRReaderModal";
import PDFUploadModal from "./components/PDFUploadModal";

import "./form.css";
import "./components/PDFUploadModal.css";

const newLine = (lastline) => ({
    product: "",
    category: "",
    quantity: "1",
    costprice: "",
    costprice_civa: "",
    total_siva: "",
    total_civa: "",
    price: "",
    iva: "",
    idposto: lastline.idposto || "",
    idpostosource: lastline.idpostosource || "",
    desc1: "",
    desc2: "",
    desc: "",
    desc_civa: "",
    value: "",
});

const knownDoctypes = [
  {
    value: "orders",
    label: "Compras",
    headers: ["datahora", "provider", "doc"],
    lines: [
      "idposto",
      "product",
      "quantity",
      "costprice",
      "costprice_civa",
      "desc1",
      "desc2",
      "desc",
      "iva",
      "pvp",
      "#lucro",
    ],
  },
  {
    value: "returns",
    label: "Devoluções",
    headers: ["datahora", "order", "provider", "obs"],
    lines: [
      "idposto",
      "product",
      "quantity",
      "costprice",
      "costprice_civa",
      "desc1",
      "desc2",
      "desc",
      "total_siva",
      "total_civa",
      "iva",
      "#pvp",
    ],
    hideAddItem: false,
    hideAddTotals: false,
  },
  {
    value: "transfer",
    label: "Transferências",
    headers: ["datahora"],
    lines: [
      "product",
      "quantity",
      "idpostosource",
      "costprice_source",
      "iva",
      "idposto",
    ],
    hideAddTotals: false,
  },
  {
    value: "quotes",
    label: "Encomendas",
    headers: ["data", "automation", "provider", "idposto"],
    lines: ["product", "quantity"],
    lines_alt: ["category"],
    condition: "automation.value == 'manual'",
    hideAddTotals: true,
    hideAddTotals_alt: true,
  },
];

const knownAutomations = [
    {
    value: "auto",
    label: "Assistida",
  },
  {
    value: "manual",
    label: "Manual",
  },
];

let products = [];

class Form extends Component {
    static contextType = UserContext;

    static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
    };

  constructor(props) {
    super(props);

    const {
      match: { params },
    } = this.props;

    this.state = {
        loaded: false,
        categories: [],
        products: [],
        providers: [],
        warehouses: [],
        postos: [],
      date: ["quotes"].includes(params.doctype)
        ? currentDate()
        : currentDateTime(),
      doc: "",
      obs: "",
        doctypes: knownDoctypes,
      doctype:
        knownDoctypes.find(({ value }) => value === params.doctype) ||
        knownDoctypes[0],
      idprovider: "",
        lines: [],
        idorder: params.idorder,
        orders: [],
      idordersource: "",
        taxes: [],
      idposto: "",
        finalized: {},
        automation: knownAutomations[0],
        automations: knownAutomations,
        indif: false,
        // Barcode modal state
        barcodeModal: {
            isOpen: false,
        barcode: "",
        lineKey: null,
        },
        // QR Reader modal state
        qrReaderModal: {
        isOpen: false,
      },
      // Posto selection modal state
      postoSelectionModal: {
        isOpen: false,
        product: null,
        existingLines: [],
      },
      // Provider creation modal state
      providerCreationModal: {
        isOpen: false,
        nif: "",
        providerData: null,
        isFetchingData: false,
        fetchError: null,
      },
      // PDF Upload modal state
      pdfUploadModal: {
        isOpen: false,
      },
        // QR Codes lidos
        scannedQRCodes: [],
        // Estados para controlo de campos numéricos
        focusedField: null,
      tempValues: {},
      // Timestamp para forçar re-render quando necessário
      lastUpdate: null,
      // Método de introdução de dados selecionado: null (não escolhido), 'manual', 'qr', 'ai'
      dataEntryMethod: null,

      lastProviderPrices: {},
    };
    this.fetchProductPrices = this.fetchProductPrices.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleInitialize = this.handleInitialize.bind(this);
    this.handleFinalize = this.handleFinalize.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.handleFormKeyDown = this.handleFormKeyDown.bind(this);
    this.loadFunction = this.loadFunction.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.addFunction = this.addFunction.bind(this);
    this.validForm = this.validForm.bind(this);
    this.invalidLines = this.invalidLines.bind(this);
    this.barcodeBuffer = "";
    this.qrBuffer = "";
    this.handleBarcodeInput = this.handleBarcodeInput.bind(this);
    this.fetchProductPricesByProvider =
      this.fetchProductPricesByProvider.bind(this);
    this.setProductLine = this.setProductLine.bind(this);
    this.shouldAlert = this.shouldAlert.bind(this);
    this.shouldAlertStockMin = this.shouldAlertStockMin.bind(this);
    this.openBarcodeModal = this.openBarcodeModal.bind(this);
    this.closeBarcodeModal = this.closeBarcodeModal.bind(this);
    this.handleProductSelected = this.handleProductSelected.bind(this);
    this.handleProductCreated = this.handleProductCreated.bind(this);
    
    // Inicializar sons de feedback
    this.successSound = new Audio('/barcode.mp3');
  }
  
  // Método para tocar som de sucesso
  playSuccessSound = () => {
    try {
      this.successSound.currentTime = 0;
      this.successSound.play().catch(err => console.log('Erro ao tocar som:', err));
    } catch (err) {
      console.log('Erro ao tocar som:', err);
    }
  }

  // Função para arredondamento inteligente
  smartRound = (value, maxDecimals = 3) => {
    if (value === null || value === undefined || value === "" || isNaN(value))
      return 0;
    const numValue = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(numValue) || numValue === 0) return 0;
    
    // Arredondar para maxDecimals casas decimais usando Math.round para evitar problemas de precisão
    const factor = Math.pow(10, maxDecimals);
    const rounded = Math.round(numValue * factor) / factor;
    
    // Converter para string e depois para número para remover zeros à direita
    // Exemplo: 1.230 vira 1.23, 1.234 fica 1.234
    const result = parseFloat(rounded.toString());
    
    return result;
  };

  // Função para calcular valores da linha
  calculateLineValues = (line, fieldName = null) => {
    const quantity = this.smartRound(Number(line.quantity) || 1, 6);
    let costprice = this.smartRound(line.costprice || 0, 6);
    let costprice_civa = this.smartRound(line.costprice_civa || 0, 6);
    let total_siva = this.smartRound(line.total_siva || 0, 6);
    let total_civa = this.smartRound(line.total_civa || 0, 6);
    const desc1 = this.smartRound(Number(line.desc1) || 0, 6);
    const desc2 = this.smartRound(Number(line.desc2) || 0, 6);
    let desc = this.smartRound(Number(line.desc) || 0, 6);
    let desc_civa = this.smartRound(Number(line.desc_civa) || 0, 6);
    const ivaTax = this.smartRound(line.iva?.tax || 0, 6);
    const price = this.smartRound(line.price || 0, 6);

    // Lógica baseada no campo alterado
    switch (fieldName) {
      case "costprice":
        // P.Uni (s/IVA) muda: P.Uni (c/IVA), Lucro (%), total (s/IVA) e total (c/IVA)
        costprice_civa = this.smartRound(costprice * (1 + ivaTax / 100), 6);
        break;
        
      case "costprice_civa":
        // P.Uni (c/IVA) muda: P.Uni (s/IVA), Lucro (%), total (s/IVA) e total (c/IVA)
        costprice = this.smartRound(costprice_civa / (1 + ivaTax / 100), 6);
        // Calcular totais diretamente a partir do preço c/IVA
        const costpriceWithDesc1ForCiva = this.smartRound(applyDiscount(costprice, desc1), 6);
        const costpriceWithDesc2ForCiva = this.smartRound(applyDiscount(costpriceWithDesc1ForCiva, desc2), 6);
        const costpriceWithDiscountsForCiva = this.smartRound(costpriceWithDesc2ForCiva - desc, 6);
        total_siva = this.smartRound(quantity * costpriceWithDiscountsForCiva, 6);
        total_civa = this.smartRound(quantity * costprice_civa, 6);
        break;
        
      case "total_siva":
        // total (s/IVA) muda: P.Uni (s/IVA), P.Uni (c/IVA), Lucro (%) e total (c/IVA)
        if (quantity > 0) {
          // Calcular preço unitário com descontos aplicados
          const costpriceWithDiscounts = this.smartRound(total_siva / quantity, 6);
          
          // Se não há descontos, o costprice é igual ao costpriceWithDiscounts
          if (desc1 === 0 && desc2 === 0 && desc === 0) {
            costprice = costpriceWithDiscounts;
          } else {
            // Reverter descontos para obter costprice original
            const costpriceWithDesc2 = this.smartRound(
              costpriceWithDiscounts + desc, 6
            );
            const costpriceWithDesc1 = this.smartRound(
              costpriceWithDesc2 / (1 - desc2 / 100), 6
            );
            costprice = this.smartRound(costpriceWithDesc1 / (1 - desc1 / 100), 6);
          }
          costprice_civa = this.smartRound(costprice * (1 + ivaTax / 100), 6);
        }
        break;
        
      case "total_civa":
        // total (c/IVA) muda: P.Uni (s/IVA), P.Uni (c/IVA), Lucro (%) e total (s/IVA)
        if (quantity > 0) {
          total_siva = this.smartRound(total_civa / (1 + ivaTax / 100), 6);
          
          // Calcular preço unitário com descontos aplicados
          const costpriceWithDiscounts = this.smartRound(total_siva / quantity, 6);
          
          // Se não há descontos, o costprice é igual ao costpriceWithDiscounts
          if (desc1 === 0 && desc2 === 0 && desc === 0) {
            costprice = costpriceWithDiscounts;
          } else {
            // Reverter descontos para obter costprice original
            const costpriceWithDesc2 = this.smartRound(
              costpriceWithDiscounts + desc, 6
            );
            const costpriceWithDesc1 = this.smartRound(
              costpriceWithDesc2 / (1 - desc2 / 100), 6
            );
            costprice = this.smartRound(costpriceWithDesc1 / (1 - desc1 / 100), 6);
          }
          costprice_civa = this.smartRound(costprice * (1 + ivaTax / 100), 6);
        }
        break;
        
      case "desc":
        // Desc. € (s/IVA) muda: Desc. € (c/IVA)
        if (ivaTax > 0) {
          desc_civa = this.smartRound(desc * (1 + ivaTax / 100), 6);
        } else {
          desc_civa = desc;
        }
        break;
        
      case "desc_civa":
        // Desc. € (c/IVA) muda: Desc. € (s/IVA)
        if (ivaTax > 0) {
          desc = this.smartRound(desc_civa / (1 + ivaTax / 100), 6);
        } else {
          desc = desc_civa;
        }
        break;
        
      case "iva":
        // IVA muda: P.Uni (c/IVA), total (c/IVA) e Desc. € (c/IVA)
        if (costprice > 0) {
          costprice_civa = this.smartRound(costprice * (1 + ivaTax / 100), 6);
        }
        // Atualizar desc_civa quando IVA muda
        if (desc > 0 && ivaTax > 0) {
          desc_civa = this.smartRound(desc * (1 + ivaTax / 100), 6);
        } else if (desc > 0 && ivaTax === 0) {
          desc_civa = desc;
        }
        break;
        
      default:
        // Para outros campos (desc1, desc2), apenas recalcular totais
        break;
    }

    // Calcular preço com descontos usando smartRound
    const costpriceWithDesc1 = this.smartRound(applyDiscount(costprice, desc1), 6);
    const costpriceWithDesc2 = this.smartRound(
      applyDiscount(costpriceWithDesc1, desc2), 6
    );
    const costpriceWithDiscounts = this.smartRound(costpriceWithDesc2 - desc, 6);
    
    // Se costprice_civa não está definido ou é 0, mas temos costprice e IVA, calcular costprice_civa
    if ((!costprice_civa || costprice_civa === 0) && costprice > 0 && ivaTax !== undefined && ivaTax >= 0) {
      costprice_civa = this.smartRound(costprice * (1 + ivaTax / 100), 6);
    }
    
    // Se IVA mudou e temos desc mas não temos desc_civa, calcular desc_civa
    if (fieldName === "iva" && desc > 0 && (!line.desc_civa || line.desc_civa === 0)) {
      if (ivaTax > 0) {
        desc_civa = this.smartRound(desc * (1 + ivaTax / 100), 6);
      } else {
        desc_civa = desc;
      }
    }
    
    // Calcular totais (exceto se foram alterados diretamente)
    if (fieldName !== "total_siva" && fieldName !== "total_civa" && fieldName !== "costprice_civa") {
      // Se não foi alterado nem total_siva nem total_civa nem costprice_civa, calcular ambos
      total_siva = this.smartRound(quantity * costpriceWithDiscounts, 6);
      total_civa = this.smartRound(total_siva * (1 + ivaTax / 100), 6);
    } else if (fieldName === "total_civa") {
      // Se foi alterado total_civa, derivar total_siva
      total_siva = this.smartRound(total_civa / (1 + ivaTax / 100), 6);
    } else if (fieldName === "total_siva") {
      // Se foi alterado total_siva, derivar total_civa
      total_civa = this.smartRound(total_siva * (1 + ivaTax / 100), 6);
    }
    // Se fieldName === "costprice_civa", os totais já foram calculados no switch acima

    // Calcular Lucro (%) se temos price
    let lucro = "";
    if (price && costprice_civa && ivaTax !== undefined) {
      const costpriceWithIva = this.smartRound(
        costpriceWithDiscounts * (1 + ivaTax / 100), 6
      );
      lucro = this.smartRound(100 - (costpriceWithIva * 100) / price, 6);
    }

    return {
      costprice: this.smartRound(costprice, 6),
      costprice_civa: this.smartRound(costprice_civa, 6),
      total_siva: this.smartRound(total_siva, 6),
      total_civa: this.smartRound(total_civa, 6),
      desc: this.smartRound(desc, 6),
      desc_civa: this.smartRound(desc_civa, 6),
      lucro: lucro,
    };
  };

  // Função para executar lógica de blur
  executeBlurLogic = (lineKey, fieldName, tempValue, line) => {
    const finalValue =
      tempValue === "" ? 0 : isNaN(Number(tempValue)) ? 0 : Number(tempValue);
    
    // Criar linha atualizada com o novo valor
    const updatedLine = { ...line, [fieldName]: finalValue };
    
    // Recalcular todos os valores da linha
    const calculatedValues = this.calculateLineValues(updatedLine, fieldName);
    
    // Atualizar todos os campos de uma vez usando setState
    this.setState((prev) => {
      // Limpar tempValues
      const newTemp = { ...prev.tempValues };
      delete newTemp[`${fieldName}-${lineKey}`];
      
      // Criar nova array de linhas
      const newLines = [...prev.lines];
      const lineIndex = parseInt(lineKey);
      
      if (newLines[lineIndex]) {
        // Criar nova linha com todos os valores atualizados
        newLines[lineIndex] = {
          ...newLines[lineIndex],
          [fieldName]: finalValue,
          // Aplicar valores calculados
          ...Object.keys(calculatedValues).reduce((acc, key) => {
            if (
              key !== fieldName &&
              calculatedValues[key] !== undefined &&
              calculatedValues[key] !== ""
            ) {
              acc[key] = calculatedValues[key];
            }
            return acc;
          }, {})
        };
      }
      
      return { 
        lines: newLines,
        tempValues: newTemp,
        // Forçar re-render adicionando timestamp para garantir que o React detecte a mudança
        lastUpdate: Date.now()
      };
    });
  };

  // Handlers genéricos para campos numéricos
  createFieldHandlers = (lineKey, fieldName, line) => {
    const fieldKey = `${fieldName}-${lineKey}`;
    
    return {
      value:
        this.state.focusedField === fieldKey
          ? this.state.tempValues[fieldKey] !== undefined
            ? this.state.tempValues[fieldKey]
            : line[fieldName] === 0
            ? ""
            : line[fieldName] || ""
          : line[fieldName] === 0
          ? ""
          : line[fieldName] || "",
      
      onFocus: () => {
        this.setState({
          focusedField: fieldKey,
          tempValues: {
            ...this.state.tempValues,
            [fieldKey]: line[fieldName] === 0 ? "" : line[fieldName] || "",
          },
        });
      },
      
      onBlur: () => {
        const tempValue = this.state.tempValues[fieldKey];
        this.executeBlurLogic(lineKey, fieldName, tempValue, line);
      },
      
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          // Chamar o método blur() nativo do input
          e.target.blur();
        }
      },
      
      onChange: (e) => {
        e.persist();
        this.setState({
          focusedField: fieldKey,
          tempValues: {
            ...this.state.tempValues,
            [fieldKey]: e.target.value,
          },
        });
      },
    };
  };

  async setProductLine(line, provider) {
    if (!line.product || !line.product.value) {
      console.warn("setProductLine called with invalid product");
      return line;
    }
    const lastOrder = await this.fetchProductPricesByProvider(
      line.product.value,
      line.idposto.value,
      provider
    );

    let lastPriceFromOrders = lastOrder.price;

    try {
      lastPriceFromOrders = this.state.lastProviderPrices[line.product.value]?.values?.find((p) => p.idposto === line.idposto.value)?.values?.[0]?.price;
    } catch {

    }

    line["price"] = lastPriceFromOrders;
    line["iva"] = this.state.taxes.find(
      (tax) => tax.code === (lastOrder.iva || line["iva"])
    );
    line["costprice"] = lastOrder.costprice;
    line["costprice_civa"] = this.smartRound(
      line["costprice"] * (1 + (line["iva"]?.tax || 0) / 100), 6
    );
    line["desc1"] = lastOrder.desc1 || 0;
    line["desc2"] = lastOrder.desc2 || 0;
    line["desc"] = lastOrder.desc || 0;
    
    // Para transferências, buscar o preço de custo do posto origem
    if (
      this.state.doctype.value === "transfer" &&
      line.idpostosource &&
      line.idpostosource.value &&
      line.product &&
      line.product.value
    ) {
      const sourcePrices = await this.fetchProductPrices(
        line.product.value,
        line.idpostosource.value
      );
      line["costprice_source"] = sourcePrices.costprice || 0;
      if (sourcePrices && sourcePrices.iva != null) {
        const ivaTax = this.state.taxes.find((tax) => tax.code === sourcePrices.iva);
        if (ivaTax) line["iva"] = ivaTax;
      }
    }
    
    // Para devoluções com Indiferenciado, buscar o último preço de custo do fornecedor
    if (
      this.state.doctype.value === "returns" &&
      this.state.indif &&
      provider &&
      line.product &&
      line.product.value
    ) {
      const lastOrderDetails = await this.fetchProductPricesByProvider(
        line.product.value,
        line.idposto.value,
        provider
      );
      line["costprice"] = lastOrderDetails.costprice || 0;
    }
    
    // Calcular totais usando a função de cálculo
    const calculatedValues = this.calculateLineValues(line);
    line["total_siva"] = calculatedValues.total_siva;
    line["total_civa"] = calculatedValues.total_civa;

    return line;
  }

  async fetchProductPricesByProvider(product, posto, provider) {
    const { idEmpresa } = this.context;
    
    try {
      if (!this.state.lastProviderPrices[product]?.providers?.[provider]) {
        const prices = await productsService.getPriceById(idEmpresa, product, provider);
        this.state.lastProviderPrices[product] = { values: prices, providers: { [provider]: prices?.find((p) => p.idposto === posto)?.last_order_details } };
      }

      const lastOrderTypeFinder =
        (this.state.lastProviderPrices[product].providers?.[provider]?.find((p) => p.idposto === posto)?.costprice && "provider") ||
        (this.state.lastProviderPrices[product].values?.find((p) => p.idposto === posto)?.values?.[0]?.costprice && "values") ||
        "";

      let lastOrder = {
        iva: 0,
        costprice: 0,
        desc1: 0,
        desc2: 0,
        desc: 0,
      };

      if (lastOrderTypeFinder === "provider") {
        lastOrder = this.state.lastProviderPrices[product].providers[provider].find((p) => p.idposto === posto);
      } else if (lastOrderTypeFinder === "values") {
        lastOrder = this.state.lastProviderPrices[product].values.find((p) => p.idposto === posto)?.values?.[0];
      }      

      return lastOrder;
    } catch (error) {
      console.error("Erro ao buscar preços por fornecedor:", error);
      return {};
    }
  }

  getProductPrices(productId, postoId) {  
    const product = products.find((p) => p.idproduct === productId) || {};

    if (product.prices) {
      const price =
        product.prices.find((p) => p.idposto === postoId)?.values?.[0] || "";
      return price;
    }

    return [];
  }

  async fetchProductPrices(productId, postoId) {
    const { idEmpresa } = this.context;
  
    try {
      const prices = await productsService.getPriceById(idEmpresa, productId);
      const price = prices.find((p) => p.idposto === postoId)?.values?.[0] || "";
      return price;
    } catch (error) {
        console.error(error);
        return [];
    }
  }

  shouldAlert(line) {
    // Add null checks to prevent errors
    if (!line || !line["product"] || !line["idposto"]) {
      return false;
    }
    
    const prices = this.getProductPrices(
      line["product"].value,
      line["idposto"].value
    );
    
    // Para shouldAlert, vamos usar apenas os dados já carregados em products
    const product = products.find((p) => p.idproduct === line["product"].value);
    const postoData = product?.prices?.find(
      (p) => p.idposto === line["idposto"].value
    );
    const lastOrder =
      postoData?.last_order_details?.find(
        (order) =>
          order.idprovider ===
          (typeof this.state.idprovider === "object"
            ? this.state.idprovider?.value
            : this.state.idprovider || "")
      ) || {};

    const compareCurrentCostprice = threeDecimal(
      applyDiscount(
        applyDiscount(line["costprice"], line["desc1"]),
        line["desc2"]
      ) - line["desc"]
    );
    const compareLastCostprice = threeDecimal(
      lastOrder.costprice
        ? applyDiscount(
            applyDiscount(lastOrder.costprice, lastOrder.desc1),
            lastOrder.desc2
          ) - lastOrder.desc
        : 0
    );
    const compareProductCostprice = threeDecimal(prices.costprice || 0);
    
    if (
      (compareLastCostprice > 0 || compareProductCostprice > 0) &&
      compareCurrentCostprice >
        (compareLastCostprice || compareProductCostprice)
    ) {
      return `Preço de custo superior ao último preço registado (${
        compareLastCostprice || compareProductCostprice
      } €)!`;
    } else {
        return false;
    }
  }

  shouldAlertStockMin(product) {
    const unit_left = product.quantity % product.stock_box;
    if (unit_left) {
      return `Faltam ${
        product.stock_box - unit_left
      } unidades para preencher uma caixa!`;
    } else {
        return false;
    }
  }

  async refreshProducts() {
    const profile = this.context;
    try {
      const productsResponse = await productsService.get(profile.idEmpresa);
      products = productsResponse.map((product) => ({
        ...product,
        value: product.idproduct,
        label:
          product.inativo === "t"
            ? `(inativo) ${product.nome}`
            : product.nome,
      }));
      // Update state to ensure products are available
      this.setState({ 
        products: products,
        productsRefreshed: Date.now() 
      });
    } catch (error) {
      console.error("Error refreshing products:", error);
    }
  }

  // Barcode modal functions
  openBarcodeModal(barcode, lineKey) {
    this.setState({
      barcodeModal: {
        isOpen: true,
        barcode: barcode,
        lineKey: lineKey,
      },
    });
  }

  closeBarcodeModal() {
    this.setState({
      barcodeModal: {
        isOpen: false,
        barcode: "",
        lineKey: null,
      },
    });
  }

  handleProductSelected(product) {
    // Tocar som de sucesso
    this.playSuccessSound();
    
    // Save lineKey before closing modal
    const lineKey = this.state.barcodeModal.lineKey;
    
    // Close modal first
    this.closeBarcodeModal();
    
    // Verificar se o produto já existe nas linhas
    const existingLineIndex = this.state.lines.findIndex(
      (line) => line.product && line.product.value === product.value
    );

    if (existingLineIndex !== -1) {
      // Produto já existe, incrementar quantidade
      const updatedLines = [...this.state.lines];
      const existingLine = updatedLines[existingLineIndex];
      
      // Calcular novos totais
      const total_siva =
        Number(existingLine.quantity + 1) *
        (applyDiscount(
          applyDiscount(existingLine.costprice, existingLine.desc1),
          existingLine.desc2
        ) -
          existingLine.desc);
      const total_civa = this.smartRound(total_siva * (1 + (existingLine.iva?.tax || 0) / 100), 6);
      
      updatedLines[existingLineIndex] = {
        ...existingLine,
        quantity: Number(existingLine.quantity) + 1,
        total_siva,
        total_civa,
      };
      
      this.setState({ lines: updatedLines });
    } else {
      // Produto não existe, adicionar à linha especificada
    this.handleChange({
      target: {
        name: `lines|${lineKey}|product`,
          value: product,
        },
    });
    }
    
    // Refresh products array after a short delay to ensure modal is closed
    setTimeout(() => {
      this.refreshProducts();
    }, 100);
  }

  handleProductCreated(product) {
    // Tocar som de sucesso
    this.playSuccessSound();
    
    // Save lineKey before closing modal
    const lineKey = this.state.barcodeModal.lineKey;
    
    // Close modal first
    this.closeBarcodeModal();
    
    // Verificar se o produto já existe nas linhas
    const existingLineIndex = this.state.lines.findIndex(
      (line) => line.product && line.product.value === product.value
    );

    if (existingLineIndex !== -1) {
      // Produto já existe, incrementar quantidade
      const updatedLines = [...this.state.lines];
      const existingLine = updatedLines[existingLineIndex];
      
      // Calcular novos totais
      const total_siva =
        Number(existingLine.quantity + 1) *
        (applyDiscount(
          applyDiscount(existingLine.costprice, existingLine.desc1),
          existingLine.desc2
        ) -
          existingLine.desc);
      const total_civa = this.smartRound(total_siva * (1 + (existingLine.iva?.tax || 0) / 100), 6);
      
      updatedLines[existingLineIndex] = {
        ...existingLine,
        quantity: Number(existingLine.quantity) + 1,
        total_siva,
        total_civa,
      };
      
      this.setState({ lines: updatedLines });
    } else {
      // Produto não existe, adicionar à linha especificada
    this.handleChange({
      target: {
        name: `lines|${lineKey}|product`,
          value: product,
        },
    });
    }
    
    // Refresh products array after a short delay to ensure modal is closed
    setTimeout(() => {
      this.refreshProducts();
    }, 100);
  }

  async loadFunction() {
    const profile = this.context;
    if (!this.state.loaded) {
      try {
        // Carregar dados em paralelo usando os services
        const [categories, productsResponse, providers, warehouses, taxes, customers, orders] = await Promise.all([
          categoriesService.get(profile.idEmpresa),
          productsService.get(profile.idEmpresa),
          providersService.get(profile.idEmpresa),
          postosService.get(profile.idEmpresa),
          taxService.get(profile.idEmpresa),
          customersService.get(profile.idEmpresa),
          this.state.doctype.value === "returns" ? ordersService.get(profile.idEmpresa, { doctype: "orders", page: 1, pageSize: 10000 }) : { entries: [] }
        ]);

        // Mapear categorias
        const mappedCategories = categories.map((category) => ({
          ...category,
          value: category.idcategoria,
          label: category.descricaocategoria,
        }));

        // Mapear produtos
        products = productsResponse.map((product) => ({
          ...product,
          value: product.idproduct,
          label:
            product.inativo === "t"
              ? `(inativo) ${product.nome}`
              : product.nome,
        }));

        // Mapear fornecedores
        const mappedProviders = providers.map((provider) => ({
          ...provider,
          value: provider.idprovider,
          label: provider.name,
        }));

        // Mapear postos/armazéns
        const mappedWarehouses = warehouses.map((warehouse) => ({
          ...warehouse,
          value: warehouse.posto,
          label:
            warehouse.nome !== ""
              ? warehouse.nome
              : warehouse.posto,
        }));

        // Mapear impostos
        const mappedTaxes = taxes.map((tax) => ({
          ...tax,
          value: tax.code,
          label: getTaxSelectLabel(tax),
        }));

        // Mapear clientes
        const mappedCustomers = customers.map((customer) => ({
          ...customer,
          value: customer.idcustomer,
          label: customer.name,
        }));

        // Mapear encomendas
        const mappedOrders = orders.entries
          .filter((order) => order.valid)
          .map((order) => ({
            ...order,
            value: order.idorder,
            label: `[${order.provider_name}] ${order.doc}`,
          }));

        // Atualizar state com todos os dados mapeados
        this.setState({
          categories: mappedCategories,
          products: products,
          providers: mappedProviders,
          warehouses: mappedWarehouses,
          postos: mappedWarehouses,
          taxes: mappedTaxes,
          customers: mappedCustomers,
          orders: mappedOrders,
          loaded: true,
        });

        // Inicializar linhas com IVA padrão
        this.setState({
          lines: [
            {
              ...newLine({}),
              iva: mappedTaxes.find((tax) => tax.code === 23),
            },
          ],
        }, () => {
          // Verificar se há dados pré-preenchidos de uma encomenda
          const hasPrefilledData = this.props.location.state?.prefilledData;
          const isNotEditMode = this.props.type !== "edit";
          
          if (hasPrefilledData && isNotEditMode) {
            const prefilled = this.props.location.state.prefilledData;
            
            // Pré-preencher o fornecedor se existir
            const provider = prefilled.idprovider 
              ? mappedProviders.find(p => p.value === prefilled.idprovider)
              : null;
            
            // Pré-preencher o posto se existir
            const posto = prefilled.idposto
              ? mappedWarehouses.find(w => w.value === prefilled.idposto)
              : null;
            
            // Pré-preencher tipo de documento
            const doctype = this.state.doctypes.find(dt => dt.value === 'orders');
            
            // Mapear as linhas da encomenda para o formato do formulário
            const prefilledLines = prefilled.lines.map((line) => {
              const product = products.find(p => p.idproduct === line.idproduct);
              const linePosto = line.idposto 
                ? mappedWarehouses.find(w => w.value === line.idposto)
                : posto;
              
              return {
                ...newLine({}),
                product: product || null,
                quantity: String(line.quantity || '1'),
                idposto: linePosto || posto,
                iva: mappedTaxes.find(tax => tax.code === 23), // IVA padrão
              };
            });
            
            this.setState({
              doctype: doctype,
              idprovider: provider,
              idposto: posto || '',
              obs: prefilled.obs || '',
              lines: prefilledLines.length > 0 ? prefilledLines : this.state.lines,
              dataEntryMethod: 'manual', // Assumir manual quando vem de conversão
              finalized: {
                ...this.state.finalized,
                datahora: true,
              },
            }, async () => {
              // Buscar preços dos produtos automaticamente para cada linha
              if (provider && prefilledLines.length > 0) {
                // Usar setProductLine para cada linha para buscar os preços
                const updatedLines = await Promise.all(
                  this.state.lines.map(async (line) => {
                    if (line.product && line.product.value && line.idposto && line.idposto.value) {
                      return await this.setProductLine(line, provider.value);
                    }
                    return line;
                  })
                );
                
                // Atualizar o state com os preços
                this.setState({ lines: updatedLines });
              }
            });
          }
        });

        // Carregar dados para modo de edição
        if (this.props.type === "edit") {
          try {
            const orderData = await ordersService.getById(profile.idEmpresa, this.state.idorder);
            const order = orderData[0] || {};

            this.setState({
              ...order,
              doctype: this.state.doctypes.find(
                ({ value }) => value === order.doctype
              ),
              idprovider: mappedProviders.find(
                ({ value }) => value === order.idprovider
              ),
              lines: order.lines.map((line) => {
                const iva = mappedTaxes.find(
                  ({ code }) => code === line.iva
                );
                const quantity = line.quantity ? line.quantity : 0;
                const costprice = line.costprice ? line.costprice : 0;
                
                // Criar linha completa para calcular valores com descontos
                const completeLine = {
                  ...line,
                  quantity: String(quantity),
                  costprice: costprice,
                  costprice_civa: line.costprice_civa || 0,
                  desc1: line.desc1 || 0,
                  desc2: line.desc2 || 0,
                  desc: line.desc || 0,
                  desc_civa: line.desc_civa || 0,
                  iva: iva,
                };
                
                // Se temos desc mas não temos desc_civa, calcular desc_civa
                if ((completeLine.desc || 0) > 0 && (!completeLine.desc_civa || completeLine.desc_civa === 0) && iva && iva.tax) {
                  completeLine.desc_civa = this.smartRound(completeLine.desc * (1 + iva.tax / 100), 6);
                } else if ((completeLine.desc || 0) > 0 && (!completeLine.desc_civa || completeLine.desc_civa === 0)) {
                  completeLine.desc_civa = completeLine.desc;
                }
                
                // Usar calculateLineValues para calcular totais considerando descontos
                // Se costprice_civa não está definido, será calculado na função
                const calculatedValues = this.calculateLineValues(completeLine);
                
                return {
                  ...line,
                  product: products.find(
                    ({ idproduct }) => idproduct === line.idproduct
                  ) || null,
                  idposto: mappedWarehouses.find(
                    ({ posto }) => posto === line.idposto
                  ) || null,
                  idpostosource: mappedWarehouses.find(
                    ({ posto }) => posto === line.idpostosource
                  ) || null,
                  iva,
                  desc: completeLine.desc,
                  desc_civa: completeLine.desc_civa,
                  costprice_civa: calculatedValues.costprice_civa,
                  total_siva: calculatedValues.total_siva,
                  total_civa: calculatedValues.total_civa,
                };
              }),
              finalized: {
                ...this.state.finalized,
                doc: true,
              },
              loaded: true,
            });
          } catch (error) {
            console.error(error);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    }
    window.addEventListener("keydown", this.handleBarcodeInput);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleBarcodeInput);
  }

  async handleBarcodeInput(event) {
    const activeElement = document.activeElement;
    const isEditingDocField = activeElement.name === "doc";
    const isEditingProviderField = activeElement.name === "idprovider";
    
    // Para returns, verificar se barcode deve ser processado baseado no campo indif
    if (this.state.doctype.value === 'returns' && !this.state.indif) {
      // Se não é indiferenciado, não processar barcode
      return;
    }
    
    // Verificar se está editando o campo "Compra" (idordersource)
    let isEditingOrderField = false;
    let element = activeElement;
    while (element && element !== document.body) {
      if (
        element.getAttribute &&
        element.getAttribute("data-field-name") === "idordersource"
      ) {
        isEditingOrderField = true;
        break;
      }
      element = element.parentElement;
    }
    
    // Verificar se está editando o campo "product"
    let isEditingProductField = false;
    element = activeElement;
    while (element && element !== document.body) {
      if (
        element.getAttribute &&
        element.getAttribute("data-field-name") === "product"
      ) {
        isEditingProductField = true;
        break;
      }
      element = element.parentElement;
    }

    // Lista de teclas especiais para filtrar
    const specialKeys = [
      "Meta", "Shift", "CapsLock", "ShiftLeft", "CapsLockLeft", "ShiftRight", "CapsLockRight",
      "Control", "ControlLeft", "ControlRight", "Alt", "AltLeft", "AltRight", "AltGraph",
      "Fn", "FnLeft", "FnRight", "OS", "OSLeft", "OSRight", "ContextMenu",
      "NumLock", "ScrollLock", "PrintScreen", "Pause", "Insert", "Delete",
      "Home", "End", "PageUp", "PageDown", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight",
      "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12",
      "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24",
      "Tab", "Escape", "Backspace", "Enter", "Space", "Process", "Unidentified"
    ];

    // Lógica para QR Code
    const shouldProcessQR = 
      (!this.validForm() && 
       (!activeElement.tagName || 
        activeElement.tagName === "BODY")) ||
      isEditingDocField ||
      isEditingOrderField ||
      isEditingProviderField;

    // Lógica para Barcode
    const shouldProcessBarcode = 
      (this.validForm() && 
       (!activeElement.tagName || 
        activeElement.tagName === "BODY")) ||
      isEditingProductField;

    // Ignorar se estiver editando outros campos ou textarea
    if (
      (activeElement.tagName === "INPUT" && !isEditingDocField && !isEditingOrderField && !isEditingProviderField && !isEditingProductField) ||
      activeElement.tagName === "TEXTAREA"
    ) {
        return;
    }

    // Processar tecla Enter
    if (event.key === "Enter") {
      // Processar QR Code
      if (shouldProcessQR && this.qrBuffer) {
        // Detectar se é QR Code (começa por "A:")
        if (
          this.qrBuffer.startsWith("A:")
        ) {
          this.handleQRScanned(this.qrBuffer, "scanner");
        } else if (this.qrBuffer.startsWith("AÇ")) {
          this.handleQRScanned(this.qrBuffer.replace(/\(/g, "*").replace(/Ç/g, ":"), "scanner");
        }
        this.qrBuffer = ""; // Clear the buffer
        return;
      }

      // Processar Barcode
      if (shouldProcessBarcode && this.barcodeBuffer) {
        const productFound = products.find(
          ({ barcodes, idproduct }) =>
            barcodes.split(" ").includes(this.barcodeBuffer) ||
            idproduct === this.barcodeBuffer
        );
        
                if (productFound) {
          // Tocar som de sucesso
          this.playSuccessSound();
          
          // Para transferências, verificar se produto existe em linhas com postos diferentes
          if (this.state.doctype.value === 'transfer') {
            // Encontrar todas as linhas com o mesmo produto
            const existingLines = this.state.lines.filter(
              (line) => line.product && line.product.value === productFound.idproduct
            );
            
            if (existingLines.length === 1) {
              // Apenas uma linha com o produto, incrementar quantidade
              const updatedLines = [...this.state.lines];
              const existingLineIndex = this.state.lines.findIndex(
                (line) => line.product && line.product.value === productFound.idproduct
              );
              updatedLines[existingLineIndex] = {
                ...updatedLines[existingLineIndex],
                quantity: Number(updatedLines[existingLineIndex].quantity) + 1,
              };
              this.setState({ lines: updatedLines });
              this.barcodeBuffer = "";
              return;
            } else if (existingLines.length > 1) {
              // Múltiplas linhas com o mesmo produto em postos diferentes
              // Mostrar modal para escolher a linha
              this.showPostoSelectionModal(productFound, existingLines);
              this.barcodeBuffer = "";
              return;
            }
          } else {
            // Para outros tipos (orders, returns, quotes), verificar se produto existe
            const existingLines = this.state.lines.filter(
              (line) => {
                if (!line.product || line.product.value !== productFound.idproduct) {
                  return false;
                }
                
                // Para returns indiferenciados, agrupar apenas por produto
                if (this.state.doctype.value === 'returns' && this.state.indif) {
                  return true; // Agrupar todas as linhas com o mesmo produto
                }
                
                // Para orders, se não há posto selecionado no cabeçalho, agrupar apenas por produto
                if (this.state.doctype.value === 'orders' && !this.state.idposto?.value) {
                  return true; // Agrupar todas as linhas com o mesmo produto quando não há posto no cabeçalho
                }
                
                // Para outros tipos, comparar posto
                const currentPostoValue = this.state.idposto?.value || 'no-posto';
                const linePostoValue = line.idposto?.value || 'no-posto';
                
                return linePostoValue === currentPostoValue;
              }
            );
            
            if (existingLines.length > 0) {
              if (existingLines.length === 1) {
                // Apenas uma linha com o produto, incrementar quantidade
                        const updatedLines = await Promise.all(
                            this.state.lines.map(async (line) => {
                    // Para returns indiferenciados, incrementar qualquer linha com o produto
                    if (this.state.doctype.value === 'returns' && this.state.indif) {
                      if (line.product && line.product.value === productFound.idproduct) {
                        const total_siva =
                          Number(line.quantity + 1) *
                          (applyDiscount(
                            applyDiscount(line.costprice, line.desc1),
                            line.desc2
                          ) -
                            line.desc);
                        const total_civa =
                          total_siva * (1 + (line.iva?.tax || 0) / 100);
                                    return {
                                        ...line,
                                        quantity: Number(line.quantity) + 1,
                                        total_siva,
                                        total_civa,
                                    };
                      }
                    } else {
                      // Para orders sem posto no cabeçalho, incrementar qualquer linha com o produto
                      if (this.state.doctype.value === 'orders' && !this.state.idposto?.value) {
                        if (line.product && line.product.value === productFound.idproduct) {
                          const total_siva =
                            Number(line.quantity + 1) *
                            (applyDiscount(
                              applyDiscount(line.costprice, line.desc1),
                              line.desc2
                            ) -
                              line.desc);
                          const total_civa =
                            total_siva * (1 + (line.iva?.tax || 0) / 100);
                          return {
                            ...line,
                            quantity: Number(line.quantity) + 1,
                            total_siva,
                            total_civa,
                          };
                        }
                      } else {
                        // Para outros tipos, comparar produto e posto
                        const currentPostoValue = this.state.idposto?.value || 'no-posto';
                        const linePostoValue = line.idposto?.value || 'no-posto';
                        
                        if (
                          line.product &&
                          line.product.value === productFound.idproduct &&
                          linePostoValue === currentPostoValue
                        ) {
                        const total_siva =
                          Number(line.quantity + 1) *
                          (applyDiscount(
                            applyDiscount(line.costprice, line.desc1),
                            line.desc2
                          ) -
                            line.desc);
                        const total_civa =
                          total_siva * (1 + (line.iva?.tax || 0) / 100);
                        return {
                          ...line,
                          quantity: Number(line.quantity) + 1,
                          total_siva,
                          total_civa,
                        };
                        }
                      }
                                }
                                return line;
                            })
                        );
                        this.setState({ lines: updatedLines });
                this.barcodeBuffer = "";
                return;
                    } else {
                // Múltiplas linhas com o mesmo produto em postos diferentes
                // Mostrar modal para escolher o posto
                this.showPostoSelectionModal(productFound, existingLines);
                this.barcodeBuffer = "";
                return;
              }
            }
          }

          // Se chegou até aqui, é um novo produto - adicionar linha
          let newLineLine = newLine(
            this.state.lines[this.state.lines.length - 1] || {}
          );
                        newLineLine.product = productFound;
                        newLineLine.quantity = 1;
                        this.setState({
                            lines: [
              ...(this.state.lines.length > 1 ||
              (this.state.lines[0] && this.state.lines[0].product)
                ? this.state.lines.filter(
                    ({ product }) => product && product.idproduct
                  )
                : []),
              newLineLine.idposto && newLineLine.product
                ? await this.setProductLine(
                    newLineLine,
                    typeof this.state.idprovider === "object"
                      ? this.state.idprovider.value
                      : this.state.idprovider
                  )
                : newLineLine,
            ],
          });
                } else {
          // Produto não encontrado, abrir modal
                    const lastLineIndex = this.state.lines.length - 1;
                    this.openBarcodeModal(this.barcodeBuffer, lastLineIndex);
                }
        this.barcodeBuffer = ""; // Clear the buffer
                    return;
                }

      // Limpar buffers se não processar
      this.barcodeBuffer = "";
      this.qrBuffer = "";
        } else {
      // Processar caracteres normais
      if (!specialKeys.includes(event.key)) {
        if (shouldProcessQR) {
          this.qrBuffer += event.key;
        } else if (shouldProcessBarcode) {
                this.barcodeBuffer += event.key;
            }
        }
    }
  }

  handleEnter = (e) => {
    if (e.key === "Enter") {
        e.preventDefault(); // Prevenir submit do formulário
        this.handleFinalize(e);
        e.target.blur();
    }
};

  handleInitialize(e) {
    let name = e.target.name;

    this.setState({
        finalized: {
            ...this.state.finalized,
        [name]: false,
      },
    });
  }

  handleFinalize(e) {
    let name = e.target.name;

    this.setState({
        finalized: {
            ...this.state.finalized,
        [name]: true,
      },
    });
  }

  // QR Reader handlers
  handleOpenQRReader = () => {
    this.setState({
      qrReaderModal: {
        isOpen: true,
      },
    });
  };

  handleCloseQRReader = (keepMethod = false) => {
    // keepMethod: true = mantém no formulário (QR lido com sucesso)
    // keepMethod: false = volta à seleção (cancelou manualmente)
    this.setState({
      qrReaderModal: {
        isOpen: false,
      },
      dataEntryMethod: keepMethod ? 'qr' : null,
    });
  };

  // Posto selection modal functions
  showPostoSelectionModal = (product, existingLines) => {
    this.setState({
      postoSelectionModal: {
        isOpen: true,
        product: product,
        existingLines: existingLines,
      },
    });
  };

  closePostoSelectionModal = () => {
    this.setState({
      postoSelectionModal: {
        isOpen: false,
        product: null,
        existingLines: [],
      },
    });
  };

  // Métodos para gerenciar o modal de criação de fornecedor
  openProviderCreationModal = (nif) => {
    this.setState({
      providerCreationModal: {
        isOpen: true,
        nif: nif,
        providerData: null,
        isFetchingData: false,
        fetchError: null,
      },
    });

    // Tentar buscar dados do fornecedor pelo NIF
    if (nif) {
      this.fetchProviderDataByNIF(nif);
    }
  };

  // Métodos para gerenciar o modal de upload de PDF
  openPDFUploadModal = () => {
    this.setState({
      pdfUploadModal: {
        isOpen: true,
      },
    });
  };

  closePDFUploadModal = (keepMethod = false) => {
    // keepMethod: true = mantém no formulário (dados confirmados com sucesso)
    // keepMethod: false = volta à seleção (cancelou manualmente)
    this.setState({
      pdfUploadModal: {
        isOpen: false,
      },
      dataEntryMethod: keepMethod ? 'ai' : null,
    });
  };

  // Métodos para gerenciar a seleção do método de introdução de dados
  selectDataEntryMethod = (method) => {
    switch (method) {
      case 'manual':
        // Para manual, simplesmente marcar como selecionado e mostrar o formulário
        this.setState({ dataEntryMethod: 'manual' });
        break;
      
      case 'qr':
        // Para QR, abrir o modal de QR
        this.setState({ dataEntryMethod: 'qr' });
        this.handleOpenQRReader();
        break;
      
      case 'ai':
        // Para AI, abrir o modal de upload de PDF
        this.setState({ dataEntryMethod: 'ai' });
        this.openPDFUploadModal();
        break;
      
      default:
        break;
    }
  };

  resetDataEntryMethod = () => {
    // Voltar à tela de seleção
    this.setState({ 
      dataEntryMethod: null,
      // Limpar dados do formulário
      lines: [],
      idprovider: "",
      doc: "",
      obs: "",
      date: ["quotes"].includes(this.state.doctype.value)
        ? currentDate()
        : currentDateTime(),
    });
  };

  // Método chamado quando um fornecedor é criado no modal de PDF
  handleProviderCreated = async (idprovider) => {
    const profile = this.context;
    try {
      // Recarregar a lista de fornecedores
      const providers = await providersService.get(profile.idEmpresa);
      
      const enrichedProviders = providers.map((provider) => ({
        ...provider,
        value: provider.idprovider,
        label: provider.name,
      }));
      
      // Aguardar o setState terminar usando Promise
      await new Promise(resolve => {
        this.setState({ providers: enrichedProviders }, resolve);
      });
      
      return true; // Indicar sucesso
    } catch (error) {
      console.error('Erro ao recarregar fornecedores:', error);
      return false;
    }
  };

  // Método para processar dados do PDF
  handlePDFDataParsed = async (data) => {
    try {
      // Atualizar dados do cabeçalho
      if (data.idprovider) {
        // Pequeno delay para garantir que o estado foi atualizado (caso o fornecedor tenha sido recém-criado)
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Encontrar o fornecedor na lista de providers
        const provider = this.state.providers.find(p => String(p.value) === String(data.idprovider));
        if (provider) {
          this.setState({ idprovider: provider });
        } else {
          // Se não encontrar, criar um objeto mínimo usando os dados do _metadata
          const supplierName = data._metadata?.supplier?.name || `Fornecedor #${data.idprovider}`;
          this.setState({ 
            idprovider: { 
              value: data.idprovider, 
              label: supplierName,
              name: supplierName,
              nif: data._metadata?.supplier?.vat_number || '',
            } 
          });
        }
      }
      
      if (data.date_time) {
        this.setState({ date: new Date(data.date_time * 1000).toISOString().slice(0, 16) });
      }
      
      if (data.doc) {
        this.setState({ doc: data.doc });
      }
      
      if (data.obs) {
        this.setState({ obs: data.obs });
      }

      // Processar linhas de produtos
      if (data.lines && data.lines.length > 0) {
        const productMappings = data._productMappings || {};
        
        // Buscar IDs únicos de produtos para fazer requisição em bulk
        const productIds = [];
        data.lines.forEach(line => {
          const mappedProduct = productMappings[data.lines.indexOf(line)];
          const productId = mappedProduct?.idproduct || line.idproduct;
          if (productId && !productIds.includes(productId)) {
            productIds.push(productId);
          }
        });
        
        // Buscar preços em bulk apenas se houver produtos
        let bulkPrices = {};
        if (productIds.length > 0 && this.context?.idEmpresa) {
          try {
            bulkPrices = await productsService.bulkGetPriceById(this.context.idEmpresa, productIds);
          } catch (error) {
            console.error('Erro ao buscar preços em bulk:', error);
          }
        }
        
        const newLines = await Promise.all(data.lines.map(async (line, index) => {
          const newLineData = newLine(index > 0 ? data.lines[index - 1] : {});
          
          
          // Preencher dados básicos
          newLineData.line = line.line || (index + 1);
          newLineData.quantity = String(line.quantity || '1');
          newLineData.costprice = String(line.costprice || '');
          newLineData.costprice_civa = String(line.costprice_civa || '');
          newLineData.desc1 = String(line.desc1 || '');
          newLineData.desc2 = String(line.desc2 || '');
          newLineData.desc = String(line.desc || '');
          newLineData.desc_civa = String(line.desc_civa || '');
          
          
          // Preencher IVA (deve ser um objeto, não apenas o número)
          if (line.iva) {
            // Tentar encontrar IVA por tax (número) ou por codeiva (string)
            const ivaObj = this.state.taxes.find(t => 
              t.tax === line.iva || t.codeiva === String(line.iva) || t.codeiva === line.iva
            );
            if (ivaObj) {
              newLineData.iva = ivaObj;
            } else {
              // Se não encontrar, criar um objeto básico
              newLineData.iva = { tax: line.iva, label: `${line.iva}%`, codeiva: String(line.iva) };
            }
          }
          
          // Verificar se há mapeamento manual do modal
          const mappedProduct = productMappings[index];
          
          if (mappedProduct) {
            // Usar produto mapeado manualmente no modal
            newLineData.product = mappedProduct;
            newLineData.idproduct = mappedProduct.idproduct;
          } else if (line.idproduct) {
            // Tentar encontrar produto se ID foi fornecido pela API
            const product = products.find(p => p.idproduct === line.idproduct);
            if (product) {
              newLineData.product = product;
              newLineData.idproduct = line.idproduct;
            } else {
              // Produto não encontrado - deixar para seleção manual
              newLineData.product = null;
              newLineData.idproduct = '';
              // Guardar a descrição para referência
              newLineData.description = line.description;
            }
          } else if (!newLineData.idproduct && line.description) {
            // Se não há ID do produto, tentar encontrar por descrição
            const product = products.find(p => 
              p.nome && p.nome.toLowerCase().includes(line.description.toLowerCase())
            );
            if (product) {
              newLineData.product = product;
              newLineData.idproduct = product.idproduct;
            } else {
              // Guardar a descrição para referência
              newLineData.description = line.description;
            }
          }
          
          // Preencher idposto se fornecido
          if (line.idposto) {
            newLineData.idposto = line.idposto;
          } else if (data._selectedPosto) {
            // Usar posto selecionado na modal (objeto completo)
            newLineData.idposto = data._selectedPosto;
          } else {
            // Se não há posto, deixar vazio para seleção manual
            newLineData.idposto = null;
          }
          if (line.idpostosource) {
            newLineData.idpostosource = line.idpostosource;
          }
          
          
          // Se temos produto e posto definidos, usar dados em bulk ou setProductLine
          let enrichedLine = newLineData;
          if (newLineData.product && newLineData.product.value && 
              newLineData.idposto && newLineData.idposto.value &&
              this.state.doctype.value === "orders") {
            
            // Tentar usar preços em bulk primeiro
            const productId = newLineData.product.value;
            const postoId = newLineData.idposto.value;
            const bulkData = bulkPrices[productId];
            
            if (bulkData && Array.isArray(bulkData)) {
              // Encontrar dados do posto específico
              const postoData = bulkData.find(p => p.idposto === postoId);
              
              if (postoData) {
                // Usar dados em cache
                enrichedLine = { ...newLineData };
                
                // Carregar PVP e IVA da API
                if (postoData.values && postoData.values.length > 0) {
                  const priceData = postoData.values[0];
                  enrichedLine.price = priceData.price || '';
                  
                  // Converter IVA string para objeto IVA correto
                  if (priceData.iva) {
                    const ivaValue = String(priceData.iva);
                    const ivaObj = this.state.taxes.find(t => 
                      String(t.codeiva) === ivaValue || 
                      String(t.code) === ivaValue
                    );
                    if (ivaObj) {
                      enrichedLine.iva = ivaObj;
                    } else {
                      // Se não encontrar, criar objeto básico
                      enrichedLine.iva = { 
                        tax: parseInt(ivaValue), 
                        codeiva: ivaValue,
                        label: `${ivaValue}%` 
                      };
                    }
                  }
                }
                
                // Encontrar último pedido para o fornecedor específico
                const providerId = typeof this.state.idprovider === "object"
                  ? this.state.idprovider?.value
                  : this.state.idprovider;
                
                if (providerId && postoData.last_order_details) {
                  const lastOrder = postoData.last_order_details.find(
                    order => order.idprovider === providerId
                  );
                  
                  if (lastOrder) {
                    enrichedLine.costprice = lastOrder.costprice || newLineData.costprice || '';
                    enrichedLine.costprice_civa = this.smartRound(
                      enrichedLine.costprice * (1 + (enrichedLine.iva?.tax || 0) / 100), 6
                    );
                    enrichedLine.desc1 = lastOrder.desc1 || 0;
                    enrichedLine.desc2 = lastOrder.desc2 || 0;
                    enrichedLine.desc = lastOrder.desc || 0;
                    
                    // Calcular totais usando a função de cálculo
                    const calculatedValues = this.calculateLineValues(enrichedLine);
                    enrichedLine.total_siva = calculatedValues.total_siva;
                    enrichedLine.total_civa = calculatedValues.total_civa;
                  } else if (postoData.average > 0) {
                    // Usar média se não há pedido específico
                    enrichedLine.costprice = postoData.average;
                    enrichedLine.costprice_civa = this.smartRound(
                      enrichedLine.costprice * (1 + (enrichedLine.iva?.tax || 0) / 100), 6
                    );
                    
                    // Calcular totais
                    const calculatedValues = this.calculateLineValues(enrichedLine);
                    enrichedLine.total_siva = calculatedValues.total_siva;
                    enrichedLine.total_civa = calculatedValues.total_civa;
                  }
                } else if (postoData.average > 0) {
                  // Usar média se não há fornecedor específico
                  enrichedLine.costprice = postoData.average;
                  enrichedLine.costprice_civa = this.smartRound(
                    enrichedLine.costprice * (1 + (enrichedLine.iva?.tax || 0) / 100), 6
                  );
                  
                  // Calcular totais
                  const calculatedValues = this.calculateLineValues(enrichedLine);
                  enrichedLine.total_siva = calculatedValues.total_siva;
                  enrichedLine.total_civa = calculatedValues.total_civa;
                }
              }
            } else {
              // Fallback para setProductLine se não há dados em bulk
              enrichedLine = await this.setProductLine(
                newLineData,
                typeof this.state.idprovider === "object"
                  ? this.state.idprovider.value
                  : this.state.idprovider
              );
            }
            
            // Manter os valores vindos da AI se existirem e forem diferentes dos calculados
            // Isso permite que valores específicos da fatura sejam preservados
            if (line.costprice) {
              enrichedLine.costprice = String(line.costprice);
            }
            if (line.costprice_civa) {
              enrichedLine.costprice_civa = String(line.costprice_civa);
            }
            if (line.desc1) {
              enrichedLine.desc1 = String(line.desc1);
            }
            if (line.desc2) {
              enrichedLine.desc2 = String(line.desc2);
            }
            if (line.desc) {
              enrichedLine.desc = String(line.desc);
            }
            if (line.desc_civa) {
              enrichedLine.desc_civa = String(line.desc_civa);
            } else if (line.desc && enrichedLine.iva && enrichedLine.iva.tax) {
              // Calcular desc_civa se temos desc mas não temos desc_civa
              enrichedLine.desc_civa = this.smartRound(
                parseFloat(line.desc) * (1 + enrichedLine.iva.tax / 100), 6
              );
            }
          } else {
            // Se não temos produto+posto, usar o price da API (se existir)
            enrichedLine.price = String(line.price || '');
          }
          
          // Recalcular totais com os valores finais
          const calculatedValues = this.calculateLineValues(enrichedLine, 'costprice');
          
          // Preservar todos os campos originais e adicionar os calculados
          const finalLine = {
            ...enrichedLine, // Preservar todos os campos (incluindo price do setProductLine)
            ...calculatedValues, // Adicionar campos calculados
            _importedByAI: true // Flag para identificar linhas importadas por AI
          };
          
          
          return finalLine;
        }));
        
        
        this.setState({ lines: newLines });
      }
      
      // Fechar modal mantendo método 'ai' (dados confirmados com sucesso)
      this.closePDFUploadModal(true);
      
    } catch (error) {
      console.error('Erro ao processar dados do PDF:', error);
    }
  };

  closeProviderCreationModal = () => {
    this.setState({
      providerCreationModal: {
        isOpen: false,
        nif: "",
        providerData: null,
        isFetchingData: false,
        fetchError: null,
      },
    });
  };

  // Método para buscar dados do fornecedor pelo NIF (seguindo o padrão do form de providers)
  fetchProviderDataByNIF = async (nif) => {
    this.setState(prevState => ({
      providerCreationModal: {
        ...prevState.providerCreationModal,
        isFetchingData: true,
        fetchError: null,
      },
    }));

    try {
      // Usar a mesma API que o formulário de providers usa
      const response = await nifService.get(nif);
      
      if (response && response.isValid) {
        // Processar dados como no formulário de providers
        const postalCodeLocalityMatch = response.address.match(/(\d{4}-\d{3})\s+(.+)/);
        const postalCode = postalCodeLocalityMatch ? postalCodeLocalityMatch[1] : null;
        const locality = postalCodeLocalityMatch ? postalCodeLocalityMatch[2].trim() : null;

        // Extract address (first line before the first newline)
        const [addressLine] = response.address.split('\n');
        const address = addressLine.trim();

        const providerData = {
          nif: nif,
          name: response.name,
          address: address + "\n" + postalCode + " " + locality,
        };

        this.setState(prevState => ({
          providerCreationModal: {
            ...prevState.providerCreationModal,
            providerData: providerData,
            isFetchingData: false,
            fetchError: null,
          },
        }));
      } else {
        this.setState(prevState => ({
          providerCreationModal: {
            ...prevState.providerCreationModal,
            providerData: null,
            isFetchingData: false,
            fetchError: null,
          },
        }));
      }
    } catch (error) {
      console.error('Erro ao buscar dados do fornecedor:', error);
      this.setState(prevState => ({
        providerCreationModal: {
          ...prevState.providerCreationModal,
          providerData: null,
          isFetchingData: false,
          fetchError: 'Erro ao buscar dados do fornecedor. Tente novamente.',
        },
      }));
    }
  };

  // Método para criar o fornecedor
  createProvider = async (providerData) => {
    try {
      const { cookies } = this.props;
      const idempresa = cookies.get("member_idempresa");
      
      const response = await providersService.set({
        ...providerData,
        idempresa: idempresa,
      });

      if (response && response !== 'NOK') {
        // Adicionar o novo fornecedor à lista de fornecedores
        const newProvider = {
          value: response.idprovider,
          label: providerData.name,
          nif: providerData.nif,
          idprovider: response.idprovider,
        };

    this.setState(prevState => ({
          providers: [...prevState.providers, newProvider],
          idprovider: newProvider,
        }));

        // Fechar o modal
        this.closeProviderCreationModal();
        
        return newProvider;
      } else {
        throw new Error('Erro ao criar fornecedor');
      }
    } catch (error) {
      console.error('Erro ao criar fornecedor:', error);
      this.setState(prevState => ({
        providerCreationModal: {
          ...prevState.providerCreationModal,
          fetchError: 'Erro ao criar fornecedor. Tente novamente.',
        },
      }));
      return null;
    }
  };

  handlePostoSelected = async (selectedLine) => {
    // Incrementar quantidade na linha selecionada
    const updatedLines = await Promise.all(
      this.state.lines.map(async (line) => {
        if (this.state.doctype.value === 'transfer') {
          // Para transferências, comparar produto, posto origem e posto destino
          if (
            line.product &&
            line.product.value === selectedLine.product.value &&
            line.idpostosource &&
            line.idpostosource.value === selectedLine.idpostosource.value &&
            line.idposto &&
            line.idposto.value === selectedLine.idposto.value
          ) {
            return {
              ...line,
              quantity: Number(line.quantity) + 1,
            };
          }
        } else {
          // Para outros tipos, comparar produto e posto
          if (
            line.product &&
            line.product.value === selectedLine.product.value &&
            line.idposto &&
            line.idposto.value === selectedLine.idposto.value
          ) {
            const total_siva =
              Number(line.quantity + 1) *
              (applyDiscount(
                applyDiscount(line.costprice, line.desc1),
                line.desc2
              ) -
                line.desc);
            const total_civa =
              total_siva * (1 + (line.iva?.tax || 0) / 100);
            return {
              ...line,
              quantity: Number(line.quantity) + 1,
              total_siva,
              total_civa,
            };
          }
        }
        return line;
      })
    );
    
    this.setState({ lines: updatedLines });
    this.closePostoSelectionModal();
  };

  handleQRScanned = (qrData, source = "camera") => {
    // Tocar som de sucesso
    this.playSuccessSound();
    
    // Adicionar QR code à lista de códigos lidos
    this.setState((prevState) => ({
      scannedQRCodes: [
        ...prevState.scannedQRCodes,
        {
        data: qrData,
        timestamp: new Date().toISOString(),
        id: Date.now(),
          source: source, // 'camera' ou 'scanner'
        },
      ],
    }));

    // Processar QR code e extrair informações
    this.processQRCode(qrData);
    
    // Se o método de entrada ainda não foi selecionado (está na tela de seleção),
    // definir automaticamente como 'qr' quando escanear via scanner
    if (source === "scanner" && !this.state.dataEntryMethod) {
      this.setState({ dataEntryMethod: 'qr' });
    }
    
    // Fechar modal após 1 segundo (apenas se veio da câmera)
    // keepMethod = true porque o QR foi lido com sucesso
    if (source === "camera") {
      setTimeout(() => {
        this.handleCloseQRReader(true); // true = mantém método 'qr' e mostra formulário
      }, 1000);
    }
  };

  processQRCode = (qrData) => {
    try {
      // Extrair informações do QR code
      const qrInfo = this.parseQRCode(qrData);
      
      if (qrInfo) {
        // Preencher fornecedor (A: NIF)
        if (qrInfo.nif && this.state.providers.length > 0) {
          const provider = this.state.providers.find(
            (p) => p.nif === qrInfo.nif || p.nif?.toString() === qrInfo.nif
          );
          
          if (provider) {
            this.handleChange({
              target: {
                name: "idprovider",
                value: provider,
              },
            });
            
            // Para devoluções, aguardar que as compras sejam recarregadas e então selecionar a compra
            if (this.state.doctype.value === "returns" && qrInfo.documentName) {
              setTimeout(() => {
                this.selectPurchaseFromQR(qrInfo.documentName);
              }, 1500); // Aguardar que as compras sejam recarregadas
            }
          } else {
            
            // Mostrar modal para criar novo fornecedor
            this.openProviderCreationModal(qrInfo.nif);
          }
        }
        
        // Preencher nome do documento (G:)
        if (qrInfo.documentName) {
          this.handleChange({
            target: {
              name: "doc",
              value: qrInfo.documentName,
            },
          });
        }
        
        // Preencher data do documento (F:) - apenas para compras, não para devoluções
        if (qrInfo.documentDate && this.state.doctype.value !== "returns") {
          // Extrair hora atual do campo data existente
          const currentDateValue = this.state.date;
          let newDateTime;

          // Verificar se o campo é datetime-local (tem hora)
          if (currentDateValue && currentDateValue.includes("T")) {
            // Formato datetime-local: YYYY-MM-DDTHH:MM
            const timePart = currentDateValue.split("T")[1] || "00:00";
            newDateTime = `${qrInfo.documentDateISO}T${timePart}`;
          } else if (currentDateValue && currentDateValue.includes(" ")) {
            // Formato com espaço: DD/MM/YYYY HH:MM:SS
            const timePart = currentDateValue.split(" ")[1] || "00:00:00";
            newDateTime = `${qrInfo.documentDate} ${timePart}`;
          } else {
            // Apenas data (sem hora)
            newDateTime = qrInfo.documentDateISO || qrInfo.documentDate;
          }

          this.handleChange({
            target: {
              name: "date",
              value: newDateTime,
            },
          });
        } else if (
          qrInfo.documentDate &&
          this.state.doctype.value === "returns"
        ) {
        }
      } else {
      }
    } catch (error) {
      console.error("Erro ao processar QR code:", error);
    }
  };

  parseQRCode = (qrData) => {
    try {
      // Limpar dados se começarem com CapsLockShiftAShift:
      let cleanData = qrData;
      if (qrData.startsWith("CapsLockShiftAShift:")) {
        cleanData = qrData.replace("CapsLockShiftAShift:", "A:");
      }
      
      const result = {};
      
      // Extrair cada campo usando regex - campos separados por *
      const fields = {
        A: "nif", // NIF do fornecedor
        G: "documentName", // Nome do documento
        F: "documentDate", // Data do documento
      };

      Object.keys(fields).forEach((key) => {
        // Regex para capturar o valor após a chave até o próximo * ou fim da string
        const regex = new RegExp(`${key}:([^*]+)(?:\\*|$)`);
        const match = cleanData.match(regex);
        if (match) {
          result[fields[key]] = match[1].trim();
        }
      });
      
      // Converter data do formato YYYYMMDD para o formato apropriado
      if (result.documentDate && result.documentDate.length === 8) {
        const year = result.documentDate.substring(0, 4);
        const month = result.documentDate.substring(4, 6);
        const day = result.documentDate.substring(6, 8);
        
        // Armazenar ambos os formatos para usar conforme necessário
        result.documentDate = `${day}/${month}/${year}`; // DD/MM/YYYY
        result.documentDateISO = `${year}-${month}-${day}`; // YYYY-MM-DD
      }
      
      return result;
    } catch (error) {
      console.error("Erro ao fazer parse do QR code:", error);
      return null;
    }
  };

  selectPurchaseFromQR = (documentName, retryCount = 0) => {
    const maxRetries = 5; // Máximo 5 tentativas
    
    
    // Calcular filteredOrders dinamicamente (mesma lógica do render)
    const { idprovider, orders } = this.state;
    const filteredOrders =
      idprovider &&
      (typeof idprovider === "object" ? idprovider.value : idprovider)
        ? orders.filter(
            ({ idprovider: oidprovider }) =>
              oidprovider ===
              (typeof idprovider === "object" ? idprovider.value : idprovider)
          )
      : orders;
    
    
    if (!orders || orders.length === 0) {
      if (retryCount < maxRetries) {
        setTimeout(() => {
          this.selectPurchaseFromQR(documentName, retryCount + 1);
        }, 1000);
        return;
      } else {
        return;
      }
    }
    
    if (filteredOrders.length === 0) {
      return;
    }
    
    // Buscar compra com diferentes critérios
    const matchingOrder = filteredOrders.find(
      (order) =>
        order.label &&
        (order.label.includes(documentName) ||
        documentName.includes(order.label) ||
          order.label === documentName)
    );
    
    if (matchingOrder) {
      // Simular a seleção no AutoCompleteField
      this.handleChange({
        target: {
          name: "idordersource",
          value: matchingOrder,
        },
      });
    } else {
    }
  };

  handleCheckboxChange(e, callback) {
    let value = e.target.checked;
    let name = e.target.name;

    this.setState({
        [name]: value,
    });
  }

  async handleChange(e, callback) {
    // Remover a lógica que causa perda de foco
    // if (!['INPUT'].includes(e.target.tagName)) {
    //     document.activeElement.blur();
    // }
    
    const profile = this.context;
    let value = e.target.value;
    let name = e.target.name;
    
    let newState = { 
      ...this.state,
      lines: [...this.state.lines],
    };

    if (name.includes("|")) {
        const properties = name.split("|");
        if (properties.length === 3) {
            // Fazer cópia profunda do objeto line antes de modificar
            newState[properties[0]][properties[1]] = {
              ...newState[properties[0]][properties[1]],
          [properties[2]]: value,
            };
        } else if (properties.length === 5) {
        newState[properties[0]][properties[1]][properties[2]][properties[3]][
          properties[4]
        ] = value;
      }

      if (
        this.state.doctype.value === "orders" &&
        newState[properties[0]][properties[1]]["idposto"] &&
        newState[properties[0]][properties[1]]["idposto"].value &&
        newState[properties[0]][properties[1]]["product"] &&
        newState[properties[0]][properties[1]]["product"].value &&
        ["idposto", "product"].includes(properties[2])
      ) {
        // Se a linha foi gerada por AI e apenas o posto está sendo alterado, não recalcular o preço
        const isAIGenerated = newState[properties[0]][properties[1]]._importedByAI === true;
        const isOnlyPostoChanged = properties[2] === "idposto";
        
        if (!(isAIGenerated && isOnlyPostoChanged)) {
          newState[properties[0]][properties[1]] = await this.setProductLine(
            newState[properties[0]][properties[1]],
            typeof this.state.idprovider === "object"
              ? this.state.idprovider.value
              : this.state.idprovider
          );
        }
        }
        
        // Para devoluções com Indiferenciado, buscar o último preço de custo quando o produto ou posto for alterado
      if (
        this.state.doctype.value === "returns" &&
        this.state.indif &&
        newState[properties[0]][properties[1]]["product"] &&
        newState[properties[0]][properties[1]]["product"].value &&
        newState[properties[0]][properties[1]]["idposto"] &&
        newState[properties[0]][properties[1]]["idposto"].value &&
        ["product", "idposto"].includes(properties[2]) &&
        this.state.idprovider &&
        (typeof this.state.idprovider === "object"
          ? this.state.idprovider.value
          : this.state.idprovider)
      ) {
        const lastOrder = await this.fetchProductPricesByProvider(
          newState[properties[0]][properties[1]]["product"].value,
          newState[properties[0]][properties[1]]["idposto"].value,
          typeof this.state.idprovider === "object"
            ? this.state.idprovider.value
            : this.state.idprovider
        );
        newState[properties[0]][properties[1]]["iva"] = this.state.taxes.find(
          (tax) => tax.code === lastOrder.iva
        );
        newState[properties[0]][properties[1]]["costprice"] =
          lastOrder.costprice || 0;
        
        // Recalcular totais após atualizar costprice para returns
        const updatedLine = newState[properties[0]][properties[1]];
        const calculatedValues = this.calculateLineValues(updatedLine);
        newState[properties[0]][properties[1]]["total_siva"] = calculatedValues.total_siva;
        newState[properties[0]][properties[1]]["total_civa"] = calculatedValues.total_civa;
        newState[properties[0]][properties[1]]["costprice_civa"] = calculatedValues.costprice_civa;
        }
        
        // Para transferências, buscar preço de custo do posto origem quando posto origem ou produto for alterado
      if (
        this.state.doctype.value === "transfer" &&
        newState[properties[0]][properties[1]]["idpostosource"] &&
        newState[properties[0]][properties[1]]["idpostosource"].value &&
        newState[properties[0]][properties[1]]["product"] &&
        newState[properties[0]][properties[1]]["product"].value &&
        ["idpostosource", "product"].includes(properties[2])
      ) {
        const sourcePrices = await this.fetchProductPrices(
          newState[properties[0]][properties[1]]["product"].value,
          newState[properties[0]][properties[1]]["idpostosource"].value
        );

        const desc1 = this.smartRound(
          sourcePrices["desc1"]
        );
        const desc2 = this.smartRound(
          sourcePrices["desc2"]
        );
        const desc = this.smartRound(
          parseFloat(sourcePrices["desc"] || 0)
        );
        const costprice = this.smartRound(
          applyDiscount(
            applyDiscount(
              sourcePrices.costprice || 0,
              desc1
            ),
            desc2
          ) - desc
        );

        newState[properties[0]][properties[1]]["costprice_source"] = costprice;
        if (sourcePrices && sourcePrices.iva != null) {
          const ivaTax = this.state.taxes.find((tax) => tax.code === sourcePrices.iva);
          if (ivaTax) newState[properties[0]][properties[1]]["iva"] = ivaTax;
        }
        }
        // Add null check for iva object
      const ivaObject = newState[properties[0]][properties[1]]["iva"];
      const pontoIva = this.smartRound(
        ivaObject && ivaObject.tax ? 1 + ivaObject.tax / 100 : 1
      );
      const desc1 = this.smartRound(
        newState[properties[0]][properties[1]]["desc1"]
      );
      const desc2 = this.smartRound(
        newState[properties[0]][properties[1]]["desc2"]
      );
      const desc = this.smartRound(
        parseFloat(newState[properties[0]][properties[1]]["desc"] || 0)
      );
      const costprice = this.smartRound(
        applyDiscount(
          applyDiscount(
            newState[properties[0]][properties[1]]["costprice"],
            desc1
          ),
          desc2
        ) - desc
      );
      const total_siva = this.smartRound(
        costprice * newState[properties[0]][properties[1]]["quantity"]
      );
      if (properties[2] === "iva") {
        newState[properties[0]][properties[1]]["costprice_civa"] =
          this.smartRound(
            newState[properties[0]][properties[1]]["costprice"] * pontoIva
          );
        // Atualizar desc_civa quando IVA muda
        if (desc > 0 && ivaObject && ivaObject.tax) {
          newState[properties[0]][properties[1]]["desc_civa"] = this.smartRound(
            desc * (1 + ivaObject.tax / 100), 6
          );
        } else if (desc > 0) {
          newState[properties[0]][properties[1]]["desc_civa"] = desc;
        }
        newState[properties[0]][properties[1]]["total_siva"] = this.smartRound(
          newState[properties[0]][properties[1]]["quantity"] *
            (applyDiscount(
              applyDiscount(
                newState[properties[0]][properties[1]]["costprice"],
                desc1
              ),
              desc2
            ) -
              desc)
        );
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          newState[properties[0]][properties[1]]["total_siva"] * pontoIva
        );
      }
      if (properties[2] === "costprice_civa") {
        newState[properties[0]][properties[1]]["costprice"] = this.smartRound(
          value / pontoIva
        );
        newState[properties[0]][properties[1]]["total_siva"] = this.smartRound(
          newState[properties[0]][properties[1]]["quantity"] *
            (applyDiscount(
              applyDiscount(
                newState[properties[0]][properties[1]]["costprice"],
                desc1
              ),
              desc2
            ) -
              desc)
        );
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          newState[properties[0]][properties[1]]["total_siva"] * pontoIva
        );
      }
      if (properties[2] === "costprice") {
        newState[properties[0]][properties[1]]["costprice_civa"] =
          this.smartRound(value * pontoIva);
        newState[properties[0]][properties[1]]["total_siva"] = this.smartRound(
          newState[properties[0]][properties[1]]["quantity"] *
            (applyDiscount(
              applyDiscount(
                newState[properties[0]][properties[1]]["costprice"],
                desc1
              ),
              desc2
            ) -
              desc)
        );
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          newState[properties[0]][properties[1]]["total_siva"] * pontoIva
        );
      }
      if (properties[2] === "total_siva") {
        newState[properties[0]][properties[1]]["costprice"] = this.smartRound(
          revertDiscount(
            revertDiscount(
              value / newState[properties[0]][properties[1]]["quantity"] + desc,
              desc2
            ),
            desc1
          )
        );
        newState[properties[0]][properties[1]]["costprice_civa"] =
          this.smartRound(
            newState[properties[0]][properties[1]]["costprice"] * pontoIva
          );
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          value * pontoIva
        );
      }
      if (properties[2] === "total_civa") {
        newState[properties[0]][properties[1]]["total_siva"] = this.smartRound(
          value / pontoIva
        );
        newState[properties[0]][properties[1]]["costprice"] = this.smartRound(
          revertDiscount(
            revertDiscount(
              newState[properties[0]][properties[1]]["total_siva"] /
                newState[properties[0]][properties[1]]["quantity"] +
                desc,
              desc2
            ),
            desc1
          )
        );
        newState[properties[0]][properties[1]]["costprice_civa"] =
          this.smartRound(
            newState[properties[0]][properties[1]]["costprice"] * pontoIva
          );
      }
      if (properties[2] === "quantity") {
        newState[properties[0]][properties[1]]["total_siva"] = this.smartRound(
          value *
            (applyDiscount(
              applyDiscount(
                newState[properties[0]][properties[1]]["costprice"],
                desc1
              ),
              desc2
            ) -
              desc)
        );
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          newState[properties[0]][properties[1]]["total_siva"] * pontoIva
        );
      }
      if (
        properties[2] === "desc1" ||
        properties[2] === "desc2" ||
        properties[2] === "desc"
      ) {
        // Se desc mudou, atualizar desc_civa
        if (properties[2] === "desc") {
          const newDesc = this.smartRound(parseFloat(value) || 0, 6);
          if (newDesc > 0 && ivaObject && ivaObject.tax) {
            newState[properties[0]][properties[1]]["desc_civa"] = this.smartRound(
              newDesc * (1 + ivaObject.tax / 100), 6
            );
          } else if (newDesc > 0) {
            newState[properties[0]][properties[1]]["desc_civa"] = newDesc;
          } else {
            newState[properties[0]][properties[1]]["desc_civa"] = 0;
          }
        }
        newState[properties[0]][properties[1]]["total_siva"] = total_siva;
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          total_siva * pontoIva
        );
      }
      if (properties[2] === "desc_civa") {
        // Se desc_civa mudou, atualizar desc
        const newDescCiva = this.smartRound(parseFloat(value) || 0, 6);
        if (newDescCiva > 0 && ivaObject && ivaObject.tax) {
          newState[properties[0]][properties[1]]["desc"] = this.smartRound(
            newDescCiva / (1 + ivaObject.tax / 100), 6
          );
        } else if (newDescCiva > 0) {
          newState[properties[0]][properties[1]]["desc"] = newDescCiva;
        } else {
          newState[properties[0]][properties[1]]["desc"] = 0;
        }
        // Recalcular totais com o novo desc
        const updatedDesc = newState[properties[0]][properties[1]]["desc"];
        const costprice = this.smartRound(
          applyDiscount(
            applyDiscount(
              newState[properties[0]][properties[1]]["costprice"],
              desc1
            ),
            desc2
          ) - updatedDesc
        );
        const newTotalSiva = this.smartRound(
          newState[properties[0]][properties[1]]["quantity"] * costprice
        );
        newState[properties[0]][properties[1]]["total_siva"] = newTotalSiva;
        newState[properties[0]][properties[1]]["total_civa"] = this.smartRound(
          newTotalSiva * pontoIva
        );
      }
      if (properties[2] === "category") {
        // Verificar se value não é null antes de acessar value.value
        if (!value || !value.value) {
          // Se value é null, não fazer a requisição
          this.setState(newState);
          return;
        }
        
        try {
          const stocks = await postosService.getStocksByIdWithParams(profile.idEmpresa, {
            date: dateToTimestamp(this.state.date),
            idposto: this.state.idposto.value,
            familia: value.value
          });

          newState[properties[0]][properties[1]]["products"] = stocks
            .filter((stock) =>
              stock.providers.length
                ? stock.providers.includes(
                    typeof this.state.idprovider === "object"
                      ? this.state.idprovider.value
                      : this.state.idprovider
                  )
                : true
            )
            .map((stock) => ({
              ...stock,
              stock_threshold_racio: stock.stock_threshold
                ? parseFloat(stock.stock_threshold) / 100
                : 0,
              stock_box: stock.stock_box ? parseFloat(stock.stock_box) : 1,
            }))
            .map((stock) => ({
              ...stock,
              stock: parseFloat(stock.stock),
              day_stock: parseFloat(stock.day_stock),
              stock_dce: parseFloat(stock.stock_dce),
            }))
            .filter(
              (stock) =>
                parseFloat(stock.stock) <
                parseFloat(stock.day_stock * stock.stock_dce) +
                  parseFloat(stock.stock_min)
            )
            .map((stock) => ({
              ...stock,
              quantity:
                stock.stock_min -
                stock.stock +
                stock.day_stock * stock.stock_dce,
            }))
            .map((stock) => ({
              ...stock,
              quantity:
                Math.ceil(
                  (stock.quantity +
                    stock.quantity * stock.stock_threshold_racio) /
                    stock.stock_box
                ) * stock.stock_box,
            }));
        } catch (error) {
          console.error(error);
        }
        }
        this.setState({
            ...newState,
        });
    } else {
        this.setState({
            [name]: value,
        });
      if (
        ["quotes"].includes(this.state.doctype.value) &&
        ((["auto"].includes(this.state.automation.value) && name === "date") ||
          (["auto"].includes(this.state.automation.value) &&
            name === "idposto"))
      ) {
            const updatedLines = await Promise.all(
                this.state.lines.map(async (line) => {
                    if (line.category && line.category.value) {
                        try {
                const stocks = await postosService.getStocksById(
                  profile.idEmpresa,
                  dateToTimestamp(value),
                  this.state.idposto.value,
                  null,
                  line.category.value
                );
            
                            const processedStocks = stocks
                  .filter((stock) =>
                    stock.providers.length
                      ? stock.providers.includes(
                          typeof this.state.idprovider === "object"
                            ? this.state.idprovider.value
                            : this.state.idprovider
                        )
                      : true
                  )
                                .map((stock) => ({
                                    ...stock,
                    stock_threshold_racio: stock.stock_threshold
                      ? parseFloat(stock.stock_threshold) / 100
                      : 0,
                    stock_box: stock.stock_box
                      ? parseFloat(stock.stock_box)
                      : 1,
                  }))
                  .map((stock) => ({
                    ...stock,
                    stock: parseFloat(stock.stock),
                    day_stock: parseFloat(stock.day_stock),
                    stock_dce: parseFloat(stock.stock_dce),
                  }))
                  .filter(
                    (stock) =>
                      parseFloat(stock.stock) <
                      parseFloat(stock.day_stock * stock.stock_dce) +
                        parseFloat(stock.stock_min)
                  )
                  .map((stock) => ({
                    ...stock,
                    quantity:
                      stock.stock_min -
                      stock.stock +
                      stock.day_stock * stock.stock_dce,
                  }))
                  .map((stock) => ({
                    ...stock,
                    quantity:
                      Math.ceil(
                        (stock.quantity +
                          stock.quantity * stock.stock_threshold_racio) /
                          stock.stock_box
                      ) * stock.stock_box,
                  }));
            
                            return {
                                ...line,
                  products: processedStocks,
                            };
                        } catch (error) {
                            console.error(error);
                            return {
                                ...line,
                  products: [],
                            };
                        }
                    }
                    return line;
                })
            );
            
            // Now setState with resolved lines
            this.setState({ lines: updatedLines });
        }
      if (name === "idordersource") {
        // Verificar se value não é null antes de acessar value.value
        if (!value || !value.value) {
          // Se value é null ou não tem value, limpar a ordem selecionada
          newState.idordersource = null;
          newState.lines = [];
          this.setState(newState);
          return;
        }
        
        try {
          const orderData = await ordersService.getById(profile.idEmpresa, value.value);
          let order = orderData[0] || {};
          
          if (value.value === "-1") {
            order = this.state.orders.find(
              ({ idorder }) => idorder === value.value
            );
          }

          this.setState({
            // ...order,
            //doctype: this.state.doctypes.find(({value}) => value === order.doctype),
            idprovider:
              order.idprovider !== "-1"
                ? this.state.providers.find(
                    ({ value }) => value === order.idprovider
                  )
                : "",
            lines:
              order.idorder !== "-1"
                ? order.lines.map((line) => {
                    const iva = this.state.taxes.find(
                      ({ code }) => code === line.iva
                    );
                    const quantity = line.quantity ? line.quantity : 0;
                    const costprice = line.costprice ? line.costprice : 0;
                    
                    // Criar linha completa para calcular valores com descontos
                    const completeLine = {
                      ...line,
                      quantity: String(quantity),
                      costprice: costprice,
                      desc1: line.desc1 || 0,
                      desc2: line.desc2 || 0,
                      desc: line.desc || 0,
                      desc_civa: line.desc_civa || 0,
                      iva: iva,
                    };
                    
                    // Se temos desc mas não temos desc_civa, calcular desc_civa
                    if ((completeLine.desc || 0) > 0 && (!completeLine.desc_civa || completeLine.desc_civa === 0) && iva && iva.tax) {
                      completeLine.desc_civa = this.smartRound(completeLine.desc * (1 + iva.tax / 100), 6);
                    } else if ((completeLine.desc || 0) > 0 && (!completeLine.desc_civa || completeLine.desc_civa === 0)) {
                      completeLine.desc_civa = completeLine.desc;
                    }
                    
                    // Usar calculateLineValues para calcular totais considerando descontos
                    const calculatedValues = this.calculateLineValues(completeLine);
                    
                    return {
                        ...line,
                    product: products.find(
                      ({ idproduct }) => idproduct === line.idproduct
                    ),
                    idposto: this.state.warehouses.find(
                      ({ posto }) => posto === line.idposto
                    ),
                    idpostosource: this.state.warehouses.find(
                      ({ posto }) => posto === line.idpostosource
                    ),
                        iva,
                        desc: completeLine.desc,
                        desc_civa: completeLine.desc_civa,
                        costprice_civa: calculatedValues.costprice_civa,
                        total_siva: calculatedValues.total_siva,
                        total_civa: calculatedValues.total_civa,
                    };
                  })
                : [{}],
            loaded: true,
          });
        } catch (error) {
          console.error(error);
        }
        }
    }
    
    if (callback) {
        callback();
    }
  }

  handleFormCancel() {
    const { history } = this.props;
    history.push("/orders");
  }

  handleFormKeyDown(e) {
    // Prevenir submit do formulário quando Enter é pressionado
    if (e.key === "Enter" && e.target.type !== "submit") {
      e.preventDefault();
    }
  }

  async handleFormSubmit(e) {
    const profile = this.context;
    const { history } = this.props;
    const doctype = this.state.doctype.value;
    e.preventDefault();
    

    // Validar se todos os produtos têm IVA definido (apenas para tipos que requerem IVA)
    if (doctype !== 'transfer' && doctype !== 'returns' && doctype !== 'quotes') {
      const linesWithoutIVA = this.state.lines.filter(line => {
        if (!line.product || !line.product.value) return false;
        
        // Verificar se tem IVA definido (suportar tanto .value quanto .tax para compatibilidade com AI)
        const ivaValue = line.iva ? (line.iva.value || line.iva.tax) : 0;
        return !line.iva || !ivaValue || ivaValue === 0;
      });

      if (linesWithoutIVA.length > 0) {
        const productNames = linesWithoutIVA
          .map(line => line.product.label || line.product.nome || `Produto ID: ${line.product.value}`)
          .join(', ');
        
        alert(`Não é possível gravar o documento. Os seguintes produtos não têm IVA definido:\n\n${productNames}\n\nPor favor, defina o IVA para todos os produtos antes de gravar.`);
        return;
      }
    }

    try {
      await ordersService.set({
        idorder: this.props.type === "edit" ? this.state.idorder : null,
        doc: ["orders"].includes(doctype)
          ? this.state.doc 
          : (["returns"].includes(doctype) ? this.state.idordersource.doc : new Date().getTime()),
        obs: this.state.obs || "",
        doctype: doctype,
        date_time: dateToTimestamp(this.state.date),
        idprovider: ["orders", "returns", "quotes"].includes(doctype)
          ? typeof this.state.idprovider === "object"
            ? this.state.idprovider.value
            : this.state.idprovider
          : -1,
        idcustomer: -1,
        payment: -1,
        idordersource:
          doctype === "returns"
            ? this.state.indif
              ? -1
              : this.state.idordersource.value
            : undefined,
        automation: this.state.automation.value,
        idposto: this.state.idposto.value,
        lines: this.state.lines.map((line) => ({
            ...line,
            product: null,
          products:
            this.state.automation.value === "auto"
              ? line.products
                ? line.products.map((product) => ({
                ...product,
                    barcode:
                      ((
                        products.find(
                          (p) => p.idproduct === product.idproduct
                        ) || {}
                      )?.barcodes.split(" ") || [])[0] || product.idproduct,
                  }))
                : []
              : [],
            idproduct: line.product ? line.product.value : null,
          barcode:
            this.state.automation.value === "manual"
              ? line.product
                ? (line.product.barcodes
                    ? line.product.barcodes.split(" ")[0]
                    : "") || line.product.idproduct
                : ""
              : "",
            idposto: line.idposto ? line.idposto.value : this.state.idposto.value,
          idpostosource:
            doctype === "transfer"
              ? line.idpostosource
                ? line.idpostosource.value
                : undefined
              : undefined,
            price: line.price ? Number(line.price) : (line.product ? Number(line.product.price || 0) : 0),
            desc: Number(line.desc || 0),
            desc_civa: Number(line.desc_civa || 0),
            desc1: Number(line.desc1 || 0),
            desc2: Number(line.desc2 || 0),
            iva: line.iva ? Number(line.iva.value || line.iva.tax || 0) : 0,
          costprice: line.costprice
            ? Number(line.costprice)
            : line.product
            ? Number(line.product.costprice || 0)
            : 0,
          costprice_civa: line.costprice
            ? Number(line.product ? line.product.costprice || 0 : 0) *
              (1 + (line.iva ? line.iva.value || line.iva.tax || 0 : 0) / 100)
            : Number(line.product ? line.product.costprice || 0 : 0) *
              (1 + (line.iva ? line.iva.value || line.iva.tax || 0 : 0) / 100),
        })),
        idempresa: profile.idEmpresa,
        idemployee: profile.idEmployee || 0,
      });
      history.push("/orders");
    } catch (error) {
      console.error(error);
    }
  }

  removeFunction(key) {
    this.setState({
        lines: this.state.lines.filter((line, index) => index !== key),
    });
  }

  addFunction(key) {
    const newLineData = newLine(this.state.lines[this.state.lines.length - 1] || {});
    
    // Para quotes, verificar se produto já existe antes de criar nova linha
    if (this.state.doctype.value === 'quotes') {
      // Verificar se há uma linha com o mesmo produto
      const existingLineIndex = this.state.lines.findIndex(line => 
        line.product && line.product.value && 
        newLineData.product && newLineData.product.value &&
        line.product.value === newLineData.product.value
      );
      
      if (existingLineIndex !== -1) {
        // Produto já existe, somar quantidades
        const updatedLines = [...this.state.lines];
        const existingLine = updatedLines[existingLineIndex];
        const newQuantity = Number(existingLine.quantity) + Number(newLineData.quantity);
        
        updatedLines[existingLineIndex] = {
          ...existingLine,
          quantity: newQuantity,
        };
        
        this.setState({ lines: updatedLines });
      } else {
        // Produto não existe, criar nova linha
        this.setState({
          lines: [
            ...this.state.lines,
            newLineData,
          ],
        });
      }
      return;
    }
    
    // Verificar se há uma linha com posto e produto vazios para agrupar
    const emptyLineIndex = this.state.lines.findIndex(line => 
      !line.product || !line.product.value || 
      !line.idposto || !line.idposto.value
    );
    
    if (emptyLineIndex !== -1) {
      // Se há uma linha vazia, usar ela em vez de criar nova
      const updatedLines = [...this.state.lines];
      updatedLines[emptyLineIndex] = {
        ...newLineData,
        // Manter a linha vazia mas com os valores padrão da nova linha
      };
      this.setState({ lines: updatedLines });
    } else {
      // Verificar se a nova linha pode ser agrupada com alguma existente
      const groupedLineIndex = this.state.lines.findIndex(line => {
        // Para returns indiferenciados, agrupar apenas por produto
        if (this.state.doctype.value === 'returns' && this.state.indif) {
          return line.product && line.product.value && 
                 newLineData.product && newLineData.product.value &&
                 line.product.value === newLineData.product.value;
        }
        
        // Para outros tipos, agrupar por produto e posto
        return line.product && line.product.value && 
               line.idposto && line.idposto.value &&
               newLineData.idposto && newLineData.idposto.value &&
               line.product.value === newLineData.product?.value &&
               line.idposto.value === newLineData.idposto.value;
      });
      
      if (groupedLineIndex !== -1) {
        // Agrupar com linha existente somando quantidades
        const updatedLines = [...this.state.lines];
        const existingLine = updatedLines[groupedLineIndex];
        
        // Somar quantidades
        const newQuantity = Number(existingLine.quantity) + Number(newLineData.quantity);
        
        // Calcular novos totais
        const costpriceWithDesc1 = this.smartRound(applyDiscount(existingLine.costprice, existingLine.desc1));
        const costpriceWithDesc2 = this.smartRound(applyDiscount(costpriceWithDesc1, existingLine.desc2));
        const costpriceWithDiscounts = this.smartRound(costpriceWithDesc2 - existingLine.desc);
        const total_siva = this.smartRound(newQuantity * costpriceWithDiscounts);
        const total_civa = this.smartRound(total_siva * (1 + (existingLine.iva?.tax || 0) / 100), 6);
        
        updatedLines[groupedLineIndex] = {
          ...existingLine,
          quantity: newQuantity,
          total_siva,
          total_civa,
        };
        
        this.setState({ lines: updatedLines });
      } else {
        // Criar nova linha
    this.setState({
          lines: [
            ...this.state.lines,
            newLineData,
          ],
    });
      }
    }
  }

  validForm() {
    const { doc, idprovider, doctype, idordersource, idposto, indif } =
      this.state;

    switch (doctype.value) {
      case "orders":
            return idprovider && doc;
      case "returns":
            return (indif || idordersource) && idprovider;
      case "quotes":
            return idprovider && idposto;
      case "transfer":
        return true;
        default:
            return false;
    }
  }

  invalidLines() {
    const { lines, doctype, automation } = this.state;

    // Verificar se há produtos sem IVA (apenas para tipos que requerem IVA)
    if (doctype.value !== 'transfer' && doctype.value !== 'returns' && doctype.value !== 'quotes') {
      const linesWithoutIVA = lines.find(line => {
        if (!line.product || !line.product.value) return false;
        
        // Verificar se tem IVA definido (suportar tanto .value quanto .tax para compatibilidade com AI)
        const ivaValue = line.iva ? (line.iva.value || line.iva.tax) : 0;
        return !line.iva || !ivaValue || ivaValue === 0;
      });

      if (linesWithoutIVA) {
        return linesWithoutIVA;
      }
    }

    switch (doctype.value) {
      case "orders":
        return lines.find(
          ({ product, quantity, idposto }) =>
            !product ||
            !product.value ||
            !quantity ||
            !idposto ||
            !idposto.value
        );
      case "transfer":
        // Verificar se há pelo menos uma linha
        if (!lines || lines.length === 0) {
          return { error: "Nenhuma linha encontrada" };
        }
        
        return lines.find(
          ({ product, quantity, idposto, idpostosource }) =>
            !product ||
            !product.value ||
            !quantity ||
            !idposto ||
            !idposto.value ||
            !idpostosource ||
            !idpostosource.value
        );
      case "quotes":
        // Verificar se há pelo menos uma linha
        if (!lines || lines.length === 0) {
          return { error: "Nenhuma linha encontrada" };
        }
        
        return lines.find(({ products, product, quantity }) =>
          automation.value === "auto"
            ? !products ||
              products.length === 0 ||
              products.find(
                ({ idproduct, quantity }) => !idproduct || !quantity || Number(quantity) <= 0
              )
            : !product || !product.value || !quantity || Number(quantity) <= 0
        );
      case "returns":
        // Verificar se há pelo menos uma linha
        if (!lines || lines.length === 0) {
          return { error: "Nenhuma linha encontrada" };
        }

        // Lógica diferente baseada no estado "Indiferenciado"
        if (this.state.indif) {
          // Indiferenciado: todas as linhas têm de ter posto, produto e quantidade > 0
          return lines.find(
            ({ product, idposto, quantity }) =>
              !product ||
              !product.value ||
              !idposto ||
              !idposto.value ||
              !quantity ||
              Number(quantity) <= 0
          );
        } else {
          // Não indiferenciado: quantidade total tem de ser > 0
          const totalQuantity = lines.reduce((total, line) => {
            return total + (Number(line.quantity) || 0);
          }, 0);
          
          if (totalQuantity <= 0) {
            return { error: "Quantidade total deve ser maior que zero" };
          }
          
          return false; // Formulário válido
        }
        default:
            return false;
    }
  }

  render() {
    const { location, history } = this.props;
    const {
        loaded,
        doc,
        obs,
        date,
        idprovider,
        providers,
        categories,
        warehouses,
        lines,
        doctype,
        idordersource,
        orders,
        idposto,
        taxes,
        automation,
        automations,
        indif,
    } = this.state;
    const cookies = new URLSearchParams(location.search);

    const results = totals(lines, doctype.value, taxes);

    const fakeIdordersource =
      idordersource && idordersource.value === "-1"
        ? orders.find(({ idorder }) => idorder === "-1")
        : idordersource;

    const filteredOrders =
      idprovider &&
      (typeof idprovider === "object" ? idprovider.value : idprovider)
        ? orders.filter(
            ({ idprovider: oidprovider }) =>
              oidprovider ===
              (typeof idprovider === "object" ? idprovider.value : idprovider)
          )
        : orders;

    const desconto = results.desconto;
    const total = results.total;
    const subtotal = results.subtotal;
    const iva = results.iva;

    // Safe evaluation of condition - only allow specific known conditions
    const evaluateCondition = (condition) => {
        if (!condition) return true;
        // Only allow specific safe conditions
        if (condition === "automation.value == 'manual'") {
        return automation.value === "manual";
      }
      if (condition === "!indif") {
        return !indif;
        }
        // Add other safe conditions as needed
        return true;
    };

    const shouldShowAddItemButton = (() => {
      // Para returns, só mostrar se for indiferenciado
      if (doctype.value === 'returns') {
        return indif;
      }
      // Para outros tipos, usar a lógica padrão
      const conditionMet = doctype.condition ? evaluateCondition(doctype.condition) : true;
      return conditionMet
            ? !doctype.hideAddItem
            : !doctype.hideAddItem_alt;
    })();

    const shouldShowTotalTable = (
      doctype.condition ? evaluateCondition(doctype.condition) : true
    )
            ? !doctype.hideAddTotals
            : !doctype.hideAddTotals_alt;

    return (
        <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
                <div className="col-xs-12">
                    <ol
                        style={{
                textAlign: "left",
                marginTop: "75px",
                        }}
                        className="breadcrumb"
                    >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li>
                <a href="/orders">Compras</a>
              </li>
                        <li className="active">
                {this.props.type === "edit" ? (
                                <span>{doc}</span>
                            ) : (
                                <span>Novo Documento</span>
                            )}
                        </li>
                    </ol>
                </div>
            </div>
            {loaded && (
            <div className="fullContainer" style={{ marginTop: "25px" }}>
                <div
                    className="col-sm-12"
                    style={{ textAlign: "center", fontSize: "10px" }}
                >
                    <div className="panel panel-default">
                        <div className="container-fluid">
                            <div className="invoice-panel">
                                <div className="header">
                                    <h1 className="invoice-title">
                                      { this.props.type === "edit" ? doc : 'Novo Documento' }
                                    </h1>
                        </div>

                    {/* Tela de seleção de método de introdução */}
                    {!this.state.dataEntryMethod && this.props.type !== "edit" && doctype.value === "orders" && (
                      <div className="data-entry-method-selection">
                        <h2 className="selection-title">Como pretende introduzir os dados?</h2>
                        <p className="selection-subtitle">Escolha o método que melhor se adequa às suas necessidades</p>
                        
                        <div className="method-cards">
                          {/* Opção Manual */}
                          <div 
                            className="method-card method-card-manual"
                            onClick={() => this.selectDataEntryMethod('manual')}
                          >
                            <div className="card-icon manual-icon">
                              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                            <h3 className="card-title">Introdução Manual</h3>
                            <p className="card-description">
                              Preencha todos os campos manualmente, linha a linha
                            </p>
                            <ul className="card-features">
                              <li>✓ Controlo total</li>
                              <li>✓ Flexibilidade máxima</li>
                              <li>✓ Sem dependências</li>
                            </ul>
                            <div className="card-cta">Introduzir Manualmente</div>
                          </div>

                          {/* Opção QR Code */}
                          <div 
                            className="method-card method-card-qr"
                            onClick={() => this.selectDataEntryMethod('qr')}
                          >
                            <div className="card-icon qr-icon">
                              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="3" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
                                <rect x="13" y="3" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
                                <rect x="3" y="13" width="8" height="8" stroke="currentColor" strokeWidth="2"/>
                                <rect x="5" y="5" width="4" height="4" fill="currentColor"/>
                                <rect x="15" y="5" width="4" height="4" fill="currentColor"/>
                                <rect x="5" y="15" width="4" height="4" fill="currentColor"/>
                                <rect x="13" y="13" width="2" height="2" fill="currentColor"/>
                                <rect x="17" y="13" width="2" height="2" fill="currentColor"/>
                                <rect x="13" y="17" width="2" height="2" fill="currentColor"/>
                                <rect x="17" y="17" width="2" height="2" fill="currentColor"/>
                                <rect x="19" y="15" width="2" height="2" fill="currentColor"/>
                                <rect x="15" y="19" width="2" height="2" fill="currentColor"/>
                              </svg>
                            </div>
                            <h3 className="card-title">Ler QR Code</h3>
                            <p className="card-description">
                              Digitalize o QR Code da fatura para preencher automaticamente os cabeçalhos
                            </p>
                            <ul className="card-features">
                              <li>✓ Rápido e eficiente</li>
                              <li>✓ Dados do cabeçalho</li>
                              <li>✓ Sem erros de digitação</li>
                            </ul>
                            <div className="card-cta">Digitalizar QR Code</div>
                            <div style={{
                              marginTop: '1rem',
                              padding: '0.75rem',
                              background: 'rgba(59, 130, 246, 0.1)',
                              border: '1px solid rgba(59, 130, 246, 0.3)',
                              borderRadius: '0.5rem',
                              fontSize: '0.75rem',
                              color: '#1e40af',
                              textAlign: 'center',
                              lineHeight: '1.4',
                              whiteSpace: 'break-spaces',
                            }}>
                              <strong><span role="img" aria-label="dica">💡</span> Dica:</strong> Se tiver um leitor de QR Code, pode ler diretamente sem clicar aqui
                            </div>
                          </div>

                          {/* Opção AI - Destaque especial */}
                          <div 
                            className="method-card method-card-ai featured"
                            onClick={() => this.selectDataEntryMethod('ai')}
                          >
                            <div className="card-badge">Recomendado</div>
                            <div className="card-icon ai-icon">
                              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              <div className="sparkle sparkle-1"><span role="img" aria-label="sparkle">✨</span></div>
                              <div className="sparkle sparkle-2"><span role="img" aria-label="sparkle">✨</span></div>
                              <div className="sparkle sparkle-3"><span role="img" aria-label="sparkle">✨</span></div>
                            </div>
                            <h3 className="card-title">Leitura AI</h3>
                            <p className="card-description">
                              Carregue uma fatura (PDF/imagem) e deixe a inteligência artificial extrair todos os dados automaticamente
                            </p>
                            <ul className="card-features">
                              <li>✓ Extração automática completa</li>
                              <li>✓ Produtos e quantidades</li>
                              <li>✓ Preços e IVA</li>
                              <li>✓ Dados do fornecedor</li>
                            </ul>
                            <div className="card-cta">Começar com AI</div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Formulário - só aparecer após seleção do método ou em modo de edição */}
                    {(doctype.value !== "orders" || (this.state.dataEntryMethod || this.props.type === "edit")) && (
                    <>
                      {/* Botão para voltar à seleção de método (apenas em modo de criação e se método foi selecionado) */}
                      {doctype.value === "orders" && this.state.dataEntryMethod && this.props.type !== "edit" && (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          marginBottom: '1rem',
                          gap: '0.5rem',
                          alignItems: 'center'
                        }}>
                          <span style={{
                            fontSize: '0.875rem',
                            color: '#6b7280',
                            fontWeight: '500'
                          }}>
                            Método: {
                              this.state.dataEntryMethod === 'manual' ? 'Manual' :
                              this.state.dataEntryMethod === 'qr' ? 'QR Code' :
                              this.state.dataEntryMethod === 'ai' ? 'AI' : ''
                            }
                          </span>
                          <button
                            type="button"
                            onClick={this.resetDataEntryMethod}
                            style={{
                              padding: '0.5rem 1rem',
                              background: '#f3f4f6',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.5rem',
                              color: '#374151',
                              fontSize: '0.875rem',
                              fontWeight: '500',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem'
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.background = '#e5e7eb';
                              e.currentTarget.style.borderColor = '#9ca3af';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.background = '#f3f4f6';
                              e.currentTarget.style.borderColor = '#d1d5db';
                            }}
                          >
                            ← Mudar Método
                          </button>
                        </div>
                      )}
                    <form
                      onSubmit={this.handleFormSubmit}
                      onKeyDown={this.handleFormKeyDown}
                    >
                                    <HeaderForm
                                        doctype={doctype}
                                        date={date}
                                        idprovider={idprovider}
                                        providers={providers}
                                        automation={automation}
                                        automations={automations}
                                        doc={doc}
                                        obs={obs}
                                        fakeIdordersource={fakeIdordersource}
                                        filteredOrders={filteredOrders}
                                        indif={indif}
                                        idposto={idposto}
                                        warehouses={warehouses}
                                                                handleChange={this.handleChange}
                                        handleInitialize={this.handleInitialize}
                                        handleFinalize={this.handleFinalize}
                                        handleEnter={this.handleEnter}
                                        handleCheckboxChange={this.handleCheckboxChange}
                                        validForm={this.validForm}
                                    />
                                    
                            {this.validForm() && (
                            <>
                          {this.state.doctype.value === "quotes" &&
                            this.state.automation.value === "auto" && (
                                    <>
                                        <h3>Fórmula</h3>
                                <pre>
                                  (STOCK_MIN - STOCK + (VENDAS_DCE × DIAS_DCE))
                                  × (1 + MARGEM)
                                </pre>
                                    </>
                                )}
                                            <ProductLines
                                                lines={lines}
                                                doctype={doctype}
                                                categories={categories}
                                                products={products}
                                                taxes={taxes}
                                                warehouses={warehouses}
                                                automation={automation}
                                                indif={indif}
                                                idprovider={idprovider}
                                                idposto={idposto}
                            idordersource={idordersource}
                                                handleChange={this.handleChange}
                                                removeFunction={this.removeFunction}
                                                shouldAlert={this.shouldAlert}
                                                shouldAlertStockMin={this.shouldAlertStockMin}
                                                openBarcodeModal={this.openBarcodeModal}
                                                createFieldHandlers={this.createFieldHandlers}
                                                calculateLineValues={this.calculateLineValues}
                                            />
                                            <AddItemButton
                                                addFunction={this.addFunction}
                                                invalidLines={this.invalidLines}
                                                shouldShowAddItemButton={shouldShowAddItemButton}
                            lines={this.state.lines}
                                            />
                                            {shouldShowTotalTable && (
                                                <TotalsSection
                                                    doctype={doctype}
                                                    total={total}
                                                    subtotal={subtotal}
                                                    desconto={desconto}
                                                    iva={iva}
                                                    ivas={results.ivas}
                                                />
                                            )}
                                            <ActionButtons
                                                handleFormCancel={this.handleFormCancel}
                                                handleFormSubmit={this.handleFormSubmit}
                                                invalidLines={this.invalidLines}
                                            />
                                        </>
                                    )}
                                </form>
                                </>
                                )}
                                {/* Fim do formulário condicional */}
                                        </div>
                                            </div>
                                                </div>
                                                    </div>
                                                </div>
            )}
            
            {/* Barcode Product Modal */}
            <BarcodeProductModal
                isOpen={this.state.barcodeModal.isOpen}
                onClose={this.closeBarcodeModal}
                barcode={this.state.barcodeModal.barcode}
                onProductSelected={this.handleProductSelected}
                onProductCreated={this.handleProductCreated}
            />
            
            {/* QR Reader Modal */}
            <QRReaderModal
                isOpen={this.state.qrReaderModal.isOpen}
                onClose={this.handleCloseQRReader}
                onQRScanned={this.handleQRScanned}
            />

            {/* PDF Upload Modal */}
            <PDFUploadModal
                isOpen={this.state.pdfUploadModal.isOpen}
                onClose={this.closePDFUploadModal}
                onDataParsed={this.handlePDFDataParsed}
                onProviderCreated={this.handleProviderCreated}
                profile={this.context}
                products={this.state.products || products}
                postos={this.state.postos}
                providers={this.state.providers}
            />

        {/* Provider Creation Modal */}
        {this.state.providerCreationModal.isOpen && (
          <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}>
            <div className="modal-content" style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '12px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '80vh',
              overflow: 'auto',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                paddingBottom: '15px',
                borderBottom: '2px solid #e9ecef'
              }}>
                <h2 style={{
                  margin: 0,
                  color: '#2c3e50',
                  fontSize: '24px',
                  fontWeight: '600'
                }}>
                  Criar Novo Fornecedor
                </h2>
                <button
                  onClick={this.closeProviderCreationModal}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                    color: '#6c757d',
                    padding: '5px'
                  }}
                >
                  ×
                </button>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <p style={{
                  margin: '0 0 20px 0',
                  color: '#495057',
                  fontSize: '16px'
                }}>
                  <strong>NIF:</strong> {this.state.providerCreationModal.nif}
                </p>
                
                {this.state.providerCreationModal.isFetchingData && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#e3f2fd',
                    borderRadius: '8px',
                    border: '1px solid #2196f3'
                  }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '2px solid #2196f3',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    <span style={{ color: '#1976d2', fontWeight: '500' }}>
                      A buscar dados do fornecedor...
                    </span>
                  </div>
                )}

                {this.state.providerCreationModal.fetchError && (
                  <div style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#ffebee',
                    borderRadius: '8px',
                    border: '1px solid #f44336',
                    color: '#c62828'
                  }}>
                    {this.state.providerCreationModal.fetchError}
                  </div>
                )}

                {this.state.providerCreationModal.providerData ? (
                  <div style={{
                    marginBottom: '20px',
                    padding: '20px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6'
                  }}>
                    <h3 style={{
                      margin: '0 0 15px 0',
                      color: '#495057',
                      fontSize: '18px'
                    }}>
                      Dados encontrados:
                    </h3>
                    <div style={{ marginBottom: '15px' }}>
                      <div><strong>Nome:</strong> {this.state.providerCreationModal.providerData.name}</div>
                      <div><strong>Morada:</strong> {this.state.providerCreationModal.providerData.address}</div>
                    </div>
                    
                    <div style={{
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'flex-end'
                    }}>
                      <button
                        onClick={() => this.createProvider(this.state.providerCreationModal.providerData)}
                        style={{
                          padding: '10px 20px',
                          backgroundColor: '#4caf50',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontWeight: '500'
                        }}
                      >
                        Criar Fornecedor
                      </button>
                      <button
                        onClick={this.closeProviderCreationModal}
                        style={{
                          padding: '10px 20px',
                          backgroundColor: '#6c757d',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer'
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                ) : !this.state.providerCreationModal.isFetchingData && (
                  <div>
                    <p style={{
                      margin: '0 0 20px 0',
                      color: '#495057'
                    }}>
                      NIF não reconhecido. Pode criar o fornecedor manualmente:
                    </p>
                    
                    <form onSubmit={(e) => {
                      e.preventDefault();
                      const formData = new FormData(e.target);
                      const providerData = {
                        nif: this.state.providerCreationModal.nif,
                        name: formData.get('name'),
                      };
                      this.createProvider(providerData);
                    }}>
                      <div style={{ marginBottom: '20px' }}>
                        <label style={{
                          display: 'block',
                          marginBottom: '5px',
                          fontWeight: '500',
                          color: '#495057'
                        }}>
                          Nome do Fornecedor *
                        </label>
                        <input
                          type="text"
                          name="name"
                          required
                          style={{
                            width: '100%',
                            padding: '12px',
                            border: '1px solid #ced4da',
                            borderRadius: '6px',
                            fontSize: '14px',
                            boxSizing: 'border-box'
                          }}
                          placeholder="Ex: Empresa ABC Lda"
                        />
                      </div>
                      
                      <div style={{
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'flex-end'
                      }}>
                        <button
                          type="button"
                          onClick={this.closeProviderCreationModal}
                          style={{
                            padding: '10px 20px',
                            backgroundColor: '#6c757d',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer'
                          }}
                        >
                          Cancelar
                        </button>
                        <button
                          type="submit"
                          style={{
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontWeight: '500'
                          }}
                        >
                          Criar Fornecedor
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Posto Selection Modal */}
        {this.state.postoSelectionModal.isOpen && (
          <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}>
            <div className="modal-content" style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '80vh',
              overflow: 'auto'
            }}>
              <h3>Produto encontrado em múltiplos postos</h3>
              <p>
                O produto <strong>{this.state.postoSelectionModal.product?.label || this.state.postoSelectionModal.product?.nome}</strong> 
                existe em {this.state.postoSelectionModal.existingLines.length} postos diferentes.
              </p>
              <p>Selecione o posto onde deseja adicionar a quantidade:</p>
              
              <div style={{ marginBottom: '20px' }}>
                {this.state.postoSelectionModal.existingLines.map((line, index) => (
                  <div key={index} style={{
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                    backgroundColor: '#f9f9f9'
                  }} onClick={() => this.handlePostoSelected(line)}>
                    {this.state.doctype.value === 'transfer' ? (
                      <>
                        <strong>Posto Origem:</strong> {line.idpostosource?.label || line.idpostosource?.nome || line.idpostosource?.value || 'Sem posto origem'}<br/>
                        <strong>Posto Destino:</strong> {line.idposto?.label || line.idposto?.nome || line.idposto?.value || 'Sem posto destino'}<br/>
                        <strong>Quantidade atual:</strong> {line.quantity}<br/>
                        <strong>Preço:</strong> {line.costprice_source ? `${line.costprice_source}€` : 'N/A'}
                      </>
                    ) : (
                      <>
                        <strong>Posto:</strong> {line.idposto?.label || line.idposto?.nome || line.idposto?.value || 'Sem posto definido'}<br/>
                        <strong>Quantidade atual:</strong> {line.quantity}<br/>
                        <strong>Preço:</strong> {line.costprice ? `${line.costprice}€` : 'N/A'}
                      </>
                    )}
                  </div>
                ))}
              </div>
              
              <button 
                onClick={this.closePostoSelectionModal}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        )}
        </div>
    );
  }
}

export default withCookies(Form);

